import TranslationsConfigType, { InterestType, NoteTypes } from './translationType';

const nbTranslations: TranslationsConfigType = {
    unavailableAccountsTitle: 'Kontoer som ikke er tilgjengelig',
    pushPopup: {
        title: 'Nyhet! Pushvarslinger er her!',
        description:
            'Ønsker du å holde deg oppdatert på endringer og ting du må ta stilling til i mobilbanken, kan du nå skru på pushvarslinger og få mer kontroll på økonomien i det daglige.',
        buttonText: 'Gå til Pushvarslinger',
        notNow: 'Ikke nå',
    },
    loans: {
        arrearsLabel: 'Mangler innbetaling',
        arrearsBalance: 'Mangler: ',
        extraDownpayment: 'Ekstra innbetaling',
        infoTextDownPayment:
            'Ved ekstra innbetaling på lån vil løpetiden reduseres, du kan se ny løpetid i nedbetalingsplanen.',
        arrearsWarning: {
            description: 'Det ser ut som du mangler en innbetaling på lånet ditt.',
            buttonText: 'Gå til innbetaling',
        },
        seeOurLoans: 'Se hva slags lån du kan få',
    },
    newLoan: {
        title: 'Trenger du lån?',
        description: 'Velg mellom flere typer lån og sjekk hvor mye du kan låne',
    },
    closeAccount: {
        nextButton: 'Neste',
        cannotDelete: 'Denne kontoen kan dessverre ikke slettes her',
        chooseAccount: 'Velg en konto',
        previousButton: 'Forrige',
        confirmTitle: 'Er du sikker på at du vil avslutte kontoen?',
        confirmText:
            'Kontoen vil slettes og du vil ikke få tilgang til den igjen. Saldo og opptjente renter vil være overført til mottakerkonto ved neste bankvirkedag.',
        confirmButton: 'Avslutt konto',
        doneButton: 'OK',
        success: 'Kontoen er slettet!',
        title: 'Avslutt konto',
        transferTo: 'Hvor ønsker du at saldo og opptjente renter skal overføres?',
        contactUs: 'Kontakt oss hvis du vil ha hjelp med dette.',
        contactUsButton: 'Kontakt oss',
        closeRecurringPayment: 'Vi kan ikke avslutte kontoen',
        closeRecurringPaymentDescription:
            'Du har faste betalingsavtaler på denne kontoen, og kan derfor ikke avslutte den. Trykk på knappen under for å endre faste betalingsavtaler.',
        closeRecurringPaymentLink: 'Til faste betalingsavtaler',
        closeCardTitle: 'Du må sperre kort først',
        closeCardText: 'Du har {} knyttet til denne kontoen som må sperres permanent, før du kan avslutte kontoen din.',
        closeCardDescription:
            'Merk at du selv må gå inn og sperre permanent det kortet du ikke velger nå. Når alt er sperret kan du starte avslutningsprosessen av kontoen på nytt.',
        card: 'kort',
        cancel: 'Avbryt',
        cardOwnerSuffix: 'sitt kort',
    },
    aboutApp: {
        version: 'Appversjon {}',
        thirdPartyLicenses: 'Tredjepartslisenser',
        privacy: 'Personvern',
    },
    accountNotFound: {
        noAccount: 'Vi beklager, denne kontoen finnes ikke.',
        toFrontPage: 'Til forsiden',
    },
    approvalItem: { overdue: 'Forfalt', overdueToday: 'Frist i dag!', deadline: 'Frist', sharedBy: 'Delt av {}' },
    add: 'Legg til',
    kidRequiredError: 'Denne mottakeren krever KID-nummer. Dette støttes ikke ennå.',
    paymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringen er fullført',
            successPlural: 'Overføringen er fullført',
            successFuture: 'Overføringen er lagt til forfall',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om overføringen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Overføringen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat overføring',
                description: 'Du la til en overføring på samme beløp til denne kontoen tidligere i dag',
                continue: 'Gå til signering',
                change: 'Endre på overføringen',
            },
        },
        PAYMENT: {
            success: 'Betalingen er fullført',
            successPlural: 'Betalingene er lagt til forfall',
            successFuture: 'Betaling er lagt til forfall',
            error: {
                heading: 'Betalingen er ikke fullført',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Betalingen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til en betaling på samme beløp til denne kontoen tidligere i dag.',
                continue: 'Gå til signering',
                change: 'Endre på betalingen',
            },
        },
        EFAKTURA: {
            success: 'eFaktura ble godkjent',
            successPlural: 'Betalingene er lagt til forfall',
            successFuture: 'Betaling er lagt til forfall',
            error: {
                heading: 'eFaktura ble ikke godkjent',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'eFaktura ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til en betaling på samme beløp til denne kontoen tidligere i dag.',
                continue: 'Gå til signering',
                change: 'Endre på eFaktura',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring er opprettet',
            successPlural: 'Faste overføringer er opprettet',
            successFuture: 'Fast overføring er opprettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste overføringen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk faste betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Overføringen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat overføring',
                description: 'Du la til en fast overføring på samme beløp til denne kontoen tidligere i dag.',
                continue: 'Gå til signering',
                change: 'Endre på overføringen',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling er opprettet',
            successPlural: 'Faste overføringer er opprettet',
            successFuture: 'Fast betaling er opprettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste betalingen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk faste betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Betalingen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til en fast betaling på samme beløp til denne kontoen tidligere i dag.',
                continue: 'Gå til signering',
                change: 'Endre på betalingen',
            },
        },
        downpayment: {
            success: 'Nedbetalingen er fullført',
            successPlural: 'Nedbetalingen er fullført',
            successFuture: 'Nedbetalingen er lagt til forfall',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om nedbetalingen ble fullført før du prøver på nytt.',
                check: 'Sjekk transaksjoner',
                checkFuturePayments: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Nedbetalingen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat nedbetaling',
                description: 'Du la til en nedbetalingen på samme beløp til denne kontoen tidligere i dag.',
                continue: 'Gå til signering',
                change: 'Endre på nedbetalingen',
            },
        },
        'efaktura-sharing': {
            success: 'Tilgang til eFaktura har blitt lagt til',
            successPlural: 'Tilganger til eFakturaene har blitt lagt til',
            successFuture: '',
            error: {
                heading: 'Oj sann!',
                description: 'Vi beklager, dette gikk ikke helt etter planen. Prøv igjen senere!',
                check: '',
                checkFuturePayments: '',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Tilgangsdelingen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre på delingen',
            },
            notCompleted: {
                title: '',
                description: '',
                continue: '',
                change: '',
            },
        },
    },
    bankidExpired: {
        header: 'Din BankID er utgått',
        nativeMessage:
            'Hvis det er din BankID Mobil som er utgått, kan du endre innloggings- og signeringsmetode selv under innstillinger.',
        nativeMessage2: 'Hvis det gjelder BankID Brikke, ta kontakt med banken for videre hjelp.',
        desktopMessage:
            'Dette kan være på grunn av utgått BankID på mobil eller bankID-brikken. Ta kontakt med banke for videre hjelp.',
        settingsLink: 'Gå til innstillinger',
    },
    stopFuturePaymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringen er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om overføringen ble slettet før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
        },
        PAYMENT: {
            success: 'Betalingen er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble slettet før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste overføringen ble slettet før du prøver på nytt.',
                check: 'Sjekk faste betalinger',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste betalingen ble slettet før du prøver på nytt.',
                check: 'Sjekk faste betalinger',
            },
        },
        FOREIGN_PAYMENT: {
            success: 'Utenlandsbetalingen er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble slettet før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
        },
        EFAKTURA: {
            success: 'eFaktura er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om eFaktura ble slettet før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
        },
    },
    updateFuturePaymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringen er oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om overføringen ble endret før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av overføringen ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        PAYMENT: {
            success: 'Betalingen er oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble endret før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av betaling ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        EFAKTURA: {
            success: 'EFakturaen ble oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om eFakturaen ble endret før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av eFaktura ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring er oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste overføringen ble endret før du prøver på nytt.',
                check: 'Sjekk faste betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av fast overføring ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling er oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste betalingen ble endret før du prøver på nytt.',
                check: 'Sjekk faste betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av fast betaling ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        FOREIGN_PAYMENT: {
            success: 'Utenlandsbetalingen er oppdatert',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble endret før du prøver på nytt.',
                check: 'Sjekk fremtidige betalinger',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av betaling ble ikke bekreftet, vil du prøve på nytt?',
                tryAgain: 'Prøv på nytt',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
    },
    accountOverview: {
        headingMobile: 'Kontoer',
        errorMessageCards:
            'Vi beklager, det har skjedd en teknisk feil så du kan ikke sjekke kredittkortene dine akkurat nå. Prøv igjen litt senere',
    },
    balance: 'Saldo',
    availableForUse: 'Tilgjengelig for bruk',
    accountViewSeeFuturePayments: 'Se fremtidige betalinger',
    accountViewErrorMessage: 'Vi beklager, vi kunne ikke hente kontoene dine på grunn av en teknisk feil',
    accountsEmptyInfo: {
        title: 'For å kunne betale må du ha en brukskonto.',
        paymentAgreementTitle: 'For å kunne opprette en AvtaleGiro må du ha en konto som tillater dette.',
        recurringPaymentTitle: 'For å kunne opprette en fast betaling må du ha en betalingskonto',
    },
    accountSkipLink: 'Hopp til betal eller overfør',
    advisor: {
        title: 'Din rådgiver',
        tlf: 'Telefon',
        mail: 'E-post',
        sendEmail: 'Send e-post',
        call: 'Ring',
    },
    avtaleGiroProposals: {
        title: 'Forslag til nye AvtaleGiro',
        update: 'Opprett AvtaleGiro',
        delete: 'Slett forslag',
        new: 'Ny AvtaleGiro',
        sureYouWantToDelete: 'Er du sikker på at du vil slette dette Avtalegiro-forslaget?',
        deletemessages: {
            success: 'Forslag er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om forlsaget ble slettet før du prøver på nytt.',
                check: 'Sjekk avtaler',
            },
        },
        proposalToAvtalegiro: 'Forslag til AvtaleGiro',
        onRepeatingEFaktura: 'Ved gjentakende eFaktura kan det ofte være smart med en AvtaleGiro i stedet',
    },
    avtaleGiroAgreement: {
        title: 'Eksisterende avtaler',
        lastPayment: 'Nyligst betalt:',
        skipLink: 'Hopp til ny AvtaleGiro',
        newAvtaleGiro: 'Ny AvtaleGiro',
        retriveAvtaleGiro: 'Hent AvtaleGiro',
        downloadAvtaleGiro: 'Hent AvtaleGiro',
        deleteDialogue: 'Er du sikker på at du vil slette din AvtaleGiro?',
        noAvtalegiro: 'Du har ikke opprettet noen AvtaleGiro enda',
        createTitle: 'AvtaleGiro',
        createDescription: 'Opprett AvtaleGiro',
        kidField: 'KID',
        kidPlaceholder: 'Legg til KID',
        maxAmount: 'Maksbeløp',
        limitAmountText: 'Maksbeløp per betaling',
        limitAmountDescription: 'Beløpet på AvtaleGiroen kan ikke overskride maksbeløpet.',
        limitAmountParagraph: 'Det lønner seg å legge inn litt ekstra som maksbeløp i tilfelle det er prisendringer.',
        limitAmountPlaceholder: 'Legg til maksbeløp',
        monthlyLimitAmountText: 'Månedlig maksbeløp',
        monthlyLimitAmountDescription:
            'Beløpet er {} maksbeløp per måned, for alle betalinger som blir gjort med denne AvtaleGiroen',
        monthlyLimitAmountPlaceholder: 'Legg til månedlig maksbeløp',
        combined: 'samlet',
        editMaxAmount: 'Endre maksbeløp',
        noteText: 'Melding',
        notePlaceholder: 'Legg til melding',
        ownText: 'Legg til eget notat',
        ownTextPlaceholder: 'Eget notat',
        amountLimitPlaceholder: 'Legg til et maksbeløp..',
        deleteAvtaleGiroInfoMessages: {
            success: 'Din AvtaleGiro er slettet',
            error: {
                heading: 'Oj sann!',
                description:
                    'Vi beklager, dette gikk ikke helt etter planen. Sjekk om din AvtaleGiro ble slettet før du prøver på nytt.',
                check: 'Sjekk avtaler',
            },
        },
        update: 'Oppdater',
        redirectLink: {
            header: 'Tips!',
            description: 'Du kan opprette dette som en AvtaleGiro hvis det er en betaling du gjør ofte',
            link: 'Se forslag til AvtaleGiro',
        },
        delayMessage: 'Vær oppmerksom på at endringer på AvtaleGiro kan ta noe tid før det oppdateres.',
        blocked: 'AvtaleGiro venter på sletting og kan ikke endres',
        avtaleGiroUpdated: 'AvtaleGiro oppdatert',
        avtaleGiroWasStoppedPayment:
            'Har du hatt en stoppet betaling? Det kan være lurt å sjekke neste virkedag at betalingen har gått igjennom.',
        avtaleGiroStoppedPaymentSendAgain: 'Send betalingen på nytt',
    },
    avtalegiroValidation: {
        emptyKID: 'Du må skrive inn KID',
        missingReceiver: 'Velg mottaker før du fyller inn KID',
        invalidToAccount: 'Det er ikke mulig å opprette AvtaleGiro på valgt mottaker',
        existingAvtalegiroAgreement: 'Det er allerede opprettet AvtaleGiro på valgt mottaker',
        createSuccess: 'AvtaleGiro er opprettet',
        updateSuccess: 'AvtaleGiro er oppdatert',
        amountTooHigh: 'Maksbeløp kan ikke være over {}',
        transactionLimitIsZero: 'Maksbeløp per betaling må være større enn 0',
        monthlyLimitIsZero: 'Maksbeløp per måned må være større enn 0',
        monthlyMaxAmountMustBeLargerThanTransactional: 'Månedlig maksbeløp må være høyere enn maksbeløp per betaling',
        transactionLimitMustBeLessThanMonthly: 'Maksbeløp per betaling må være lavere enn månedlig maksbeløp',
        error: {
            heading: 'Oj sann!',
            description:
                'Vi beklager, dette gikk ikke helt etter planen. Sjekk om din AvtaleGiro ble fullført før du prøver på nytt.',
            check: 'Sjekk avtaler',
        },
        notSigned: {
            heading: 'Oj sann!',
            description: 'AvtaleGiro ble ikke bekreftet, vil du prøve på nytt?',
            tryAgain: 'Prøv på nytt',
            change: 'Endre AvtaleGiro',
            cancel: 'Avbryt oppdateringen',
        },
        notSignedUpdate: {
            heading: 'Oj sann!',
            description: 'Endring av AvtaleGiro ble ikke bekreftet, vil du prøve på nytt?',
            tryAgain: 'Prøv på nytt',
            change: 'Endre',
            cancel: 'Avbryt',
        },
        rejected: {
            heading: 'Din AvtaleGiro ble ikke opprettet',
            description:
                'Det ser ut som det er en annen AvtaleGiro med samme KID nummer på denne mottakeren. Sjekk om opplysningene stemmer.',
            tryAgain: 'Endre AvtaleGiro',
        },
    },
    approvalItemType: {
        EFAKTURA: 'eFaktura',
        WAITING_FOR_SIGNING: 'Påbegynt betaling',
        EXPIRED: 'Utgått betaling',
        REJECTED: 'Betaling feilet',
        STOPPED: 'Stoppet',
        UNKNOWN: 'Ukjent',
    },
    eFakturaItemType: {
        EFAKTURA: 'eFaktura',
        EFAKTURA_WITH_AVTALEGIRO: 'eFaktura med AvtaleGiro',
        REMINDER: 'Purring',
        ENFORCEMENT_WARNING: 'Purring 2',
        COLLECTION_NOTICE: 'Inkassovarsel',
        CREDIT_NOTE: 'Innbetaling',
        DUNNING: 'Purring 3',
        PAYMENT_REQUEST: 'Purring inkasso',
    },
    taskManager: {
        emptyState: 'Her var det stille og rolig',
        noTasks: 'Du har ingen oppgaver som venter',
        multipleErrors: {
            title: 'Noen tjenester er ustabile',
            description: 'Vi klarte ikke hente {}',
            and: 'og',
        },
        errors: {
            outbox: 'betalinger til godkjenning',
            stopped: 'stoppede betalinger',
            documents: 'dokumenter til signering',
            eFaktura: 'eFaktura',
            'loan-application': 'lånesøknader',
            kredittbanken: 'kredittbanken oppgaver',
        },
    },
    stoppedPayments: {
        title: 'Feilede betalinger',
        error: 'Vi beklager, vi det har skjedd en teknisk feil så du kan ikke sjekke feilede betalinger akkurat nå. Prøv igjen litt senere.',
        empty: 'Fant ingen feilede betalinger',
        label: {
            UNKNOWN: 'Stoppet',
            INSUFICIENT_FUNDS: 'Manglende dekning på konto',
            EXCEEDING_MAX_LIMIT: 'Betalingen overskrider beløpsgrensen',
            INVALID_CID: 'Ugyldig KID nummer',
            STOPPED_BY_USER: 'Manuelt stoppet',
            CANCELLED_BY_USER: 'Manuelt kansellert',
            INSUFFICIENT_ACCESS: 'Mangler tilgang til konto',
            CANCELLED_BY_BANK: 'Kansellert av banken',
        },
        detailedDescription: {
            UNKNOWN:
                'Betalingen ble stoppet, se over betalingen og prøv på nytt. Hvis problemet vedvarer kan du kontakte oss for nærmere informasjon',
            INSUFICIENT_FUNDS:
                'Betalingen kunne ikke fullføres på grunn av manglende dekning på konto. Overfør til konto eller velg en annen konto.',
            EXCEEDING_MAX_LIMIT: 'Betalingen kunne ikke fullføres på grunn av at den overskrider beløpsgrensen.',
            INVALID_CID:
                'Betalingen kunne ikke fullføres fordi KID-nummeret brukt i betalingen ikke var gyldig. Se over KID-nummeret og prøv på nytt.',
            STOPPED_BY_USER: 'Betalingen ble manuelt stoppet av deg eller av noen andre som disponerer denne kontoen.',
            CANCELLED_BY_USER:
                'Betalingen ble manuelt kansellert av deg eller av noen andre som har tilgang til denne kontoen.',
            INSUFFICIENT_ACCESS: 'Betalingen kunne ikke fullføres fordi du mangler bruksrettigheter på denne kontoen.',
            CANCELLED_BY_BANK: 'Betalingen ble stoppet av banken. Kontakt oss for nærmere informasjon.',
        },
        exeedingMaxLimitAvtalegiro:
            'Betalingen overskrider satt beløpsgrense. Etter at du har justert maksbeløpet, kan du sende betalingen til betalingskø.',
        exeedingMaxLimitAvtalegiroNotFound:
            'Betalingen overskrider satt beløpsgrense. Gå til AvtaleGiroen å endre maksbeløpet og prøv deretter å sende denne betalingen på nytt. {}',
        editPaymentLimitsHere: 'Endre beløpsgrensen her',
        goToAccount: 'Gå til konto',
        findAvtalegiroHere: 'Finn AvtaleGiroen her.',
    },
    approve: 'Godkjenn',
    balanceAfterPayment: 'Saldo etter {}',
    birthdayMessage: {
        title: 'Hipp hipp hurra! Gratulerer med dagen!',
        title18: 'Hipp hipp hurra for deg som har blitt 18 år!',
        description:
            'Gratulerer så mye med dagen! Vi i banken ønsker deg en fantastisk bursdag. Du er en verdsatt kunde hos oss.',
        description18:
            'Når du fyller 18 år er det kun du som har tilgang til din bankkonto. Oppdater din kontaktinformasjon og få full oversikt!',
        linkText18: 'Hva skjer når du fyller 18 år?',
        buttonText: 'Hurra!',
    },
    biometricType: {
        faceID: 'ansiktsgjenkjenning',
        fingerID: 'fingeravtrykk',
        biometrics: 'biometri',
        none: '',
    },
    bsuAccount: 'bsu-konto',
    bsuDetails: {
        displayYearly: 'Hittil i år',
        displayTotal: 'Totalt',
        amountSaved: 'Du kan spare {} til',
        saldo: 'Total saldo',
        maximumAmount: 'Maksbeløp',
        interestThisYear: 'Renter hittil i år',
        infoMessage: 'For å ta penger ut av BSU konto må du ta kontakt med oss',
        ageWarningMessage: 'Siden du er over 34 år kan du ikke lenger sette inn penger på BSU kontoen din',
        interest: 'Rente BSU',
        accruedInterest: 'Opptjente renter',
        bsuMaxAmountReached: 'Gratulerer – du er ett steg nærmere egen bolig!',
        maxAmountThisYear: 'Du har spart årlig maksbeløp for BSU',
        hasRecurringPaymentInfoCardTitle: 'Endre fast sparing i BSU',
        hasRecurringPaymentInfoCardText: 'Du sparer i dag {} kr i måneden.',
        noRecurringPaymentInfoCardTitle: 'Start fast sparing i BSU',
        noRecurringPaymentInfoCardText: 'Du sparer i dag 0 kr i måneden.',
    },
    cancel: 'Avbryt',
    cancelPaymentDialogue: {
        title: 'Er du sikker på at du vil avbryte?',
        closeDialogue: 'Nei, fortsett',
    },
    chooseAnotherAccount: 'Velg en annen konto',
    chooseOperation: 'Betal og overfør',
    close: 'Lukk',
    creditCard: 'Kredittkort',
    customerRole: {
        OWNER: 'Eier',
        DISPOSAL: 'Disponent',
        COLLATERAL: 'Sikkerhet',
        GUARANTOR: 'Garantist',
        COOWNER: 'Medeier',
        CODEBTOR: 'Medlåntaker',
        GUARDIAN: 'Verge',
        ACCESS: 'Tilgang',
        ADDRESSEE: 'Adresat',
        CREDITOR: 'Kreditor',
        CONTACT: 'Kontakt',
        UNKNOWN: 'Ukjent',
    },
    payToAForeignCountry: 'Betal til utlandet',
    crossBorderReceiverListTitle: 'Mottakerliste utland',
    crossBorderReceiverUpdateMessage: 'Endring av mottakeren kan gjøres under betaling',
    crossBorderPayment: {
        calculatedExchangeRate: 'Foreløpig beregnet beløp',
        exchangeRate: 'Foreløpig kurs ',
        numbersInNameInfoMessage:
            'Her er det kun tillatt med navn. Navn som inneholder tall er bare mulig på bedrifter. Skriv i så fall hele bedriftens navn.',
        needOneCharacter: 'Du må ha minst én bokstav i navnet.',
        amountSubTitle: 'Legg til beløp',
        currencyExchangeError: 'Kunne ikke hente foreløpig beregnet kurs',
        label: {
            IBAN: 'IBAN',
            BBAN: 'BBAN',
        },
        bic: 'BIC',
        addBic: 'Legg til BIC',
        requiredBicMessage: 'Du må legge til BIC fordi du ikke har valgt den offisielle valutaen i mottaker landet.',
        statusTitle: 'Utenlandsbetaling er ikke aktivert',
        statusDescription: 'For å kunne betale til utlandet må du ringe banken og aktivere det først',
        statusButton: 'Kontakt oss',
        desktopAmountTitle: 'Beløp, valuta og dato',
        domesticPaymentWarning:
            'Vær oppmerksom på at du har valgt å betale i NOK til et norsk kontonummer. Vi anbefaler ikke å bruke utenlandsbetaling til dette.',
        kinaInfo: 'Merk at du kun kan betale i CNY til bedrifter, ikke til privatpersoner',
        messageReceiver: 'Legg ved en melding mottaker',
        accountList: {
            title: 'Betale til utlandet',
            description:
                'Her kan du betale til de fleste land i verden. Husk å ha all informasjon klar før du begynner. Prisene for utlandsbetaling finner du i prislisten.',
            priceListLink: 'Se prisliste',
            noAccountsTitle: 'Du har ingen kontoer hos oss',
            noAccountsDescription: 'For å betale til utlandet må du opprette en konto først. ',
            createAccountLink: 'Opprett konto',
            payFrom: 'Betal fra',
            label: 'Velg blant dine kontoer',
            button: 'Neste',
            errorMessage: 'Du må velge en konto.',
        },
        categoryList: {
            title: 'Velg kategori',
            label: 'Hvilken kategori passer best til din betaling?',
            showMore: 'Vis flere',
            showLess: 'Vis færre',
            error: 'På grunn av en teknisk feil klarte vi ikke å hente listen med kategorier.',
            errorMessage: 'Du må velge kategori for å kunne gå videre',
        },
        description: {
            title: 'Beskrivelse på betaling',
            placeholder: 'Skriv her',
            descriptionLabel: 'Beskriv hva betalingen gjelder',
            messageLabel: 'Legg ved en melding til mottaker',
            descriptionError: 'Du må skrive en beskrivelse av betalingen',
            messageError: 'Du må skrive en melding til mottakeren',
            tooManyCharacters: 'Du kan ikke ha mer enn {} tegn i beskrivelsen.',
        },
        newReceiver: {
            title: 'Legg til mottaker',
            subTitle: 'Hvor skal pengene?',
            creditorInfo: 'Om mottaker',
            receiverNameLabel: 'Fullt navn/firmanavn',
            createNewReceiverTab: 'Utland',
            countryLabel: 'Mottakers land',
            countryPlaceholder: 'Søk på land',
            ibanLabel: 'IBAN',
            chooseBetween: 'Velg mellom',
            bicLabel: 'SWIFT eller BIC',
            bbanLabel: 'BBAN',
            nationalIdLabel: 'Bankkode',
            addressPlaceholder: 'Gatenavn og husnummer',
            address: 'Adresse',
            receiverAddress: 'Mottakers adresse',
            receiverBank: 'Mottakers bank',
            receiverCountry: 'Mottakers land',
            postalCode: 'Postnummer',
            city: 'Poststed',
            bankCountry: 'Bankens land',
            errorCountryTitle: 'Vi beklager!',
            errorCountry: 'På grunn av en teknisk feil klarte vi ikke å hente listen med land.',
            errorCountryDetails:
                'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å hente detaljer for landet du valgte.',
            errorReceiverList: 'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å hente mottakerne dine',
            errorBankValidation:
                'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å hente informasjon om mottakerbanken.',
            emptyBankValidation:
                'Kontonummer er gyldig, men vi finner ikke informasjon om mottakers bank. Kontakt oss for å betale til denne mottakeren.',
            errorValidToPayReceiver:
                'Det er dessverre ikke mulig å betale til denne mottakeren. Ta kontakt med oss hvis du trenger hjelp.',
            errorIban: 'Du har skrevet et ugyldig IBAN nummer',
            errorIbanValidation:
                'Vi beklager, det har skjedd en teknisk feil ved valideringen bankinformasjonen. Sjekk om korrekt informasjon er skrevet inn.',
            errorIbanCountryCode: 'IBAN nummer er ikke gyldig for det landet du har valgt',
            errorValidation: 'Du har skrevet ugyldig informasjon',
            missingAccountNumber: 'Du må fylle ut kontonummer for å kunne gå videre',
            validForPaymentError: 'Det er ikke mulig å foreta en betaling til det valgte landet.',
            paymentOptions: 'Velg betalingstype',
            accountNumberError: 'Kontonummer er ikke gyldig',
            bicError: 'BIC/SWIFT er ikke gyldig',
            missingBic: 'Du må fylle ut BIC/SWIFT for å kunne gå videre',
            missingBankBic: 'Banken støtter ikke betalinger fra utlandet',
            missingNationalId: 'Du må fylle ut bankkode for å kunne gå videre',
            missingCreditorDetails: 'Du må fylle ut adresse',
            missingPostCode: 'Du må fylle ut postnummer',
            missingTown: 'Du må fylle ut poststed',
            receiverNameError: 'Du må fylle ut et navn på mottaker',
            selectedCountryError: 'Du må velge et land',
            nationalIdError: 'Bankkoden er ikke gyldig',
            bankDetailsError: 'Beklager, vi klarte ikke å hente nødvendig informasjon om bankens land.',
        },
        summary: {
            title: 'Se over og betal',
            payFrom: 'Du betaler fra {}',
            payTo: ' til {}',
            payToCountry: 'i {} {}',
            showSummary: 'Se hele oppsummeringen',
            closeSummary: 'Lukk oppsummeringen',
            receiver: 'Mottaker',
            amount: 'Beløp',
            amountDateTitle: 'Beløp, valuta og dato',
            messageAndDescription: 'Beskrivelse og melding',
            messageToReceiver: 'Melding til mottaker',
            category: 'Kategori',
            chosenCategory: 'Valgt kategori',
            errorDescription: 'Noe gikk galt, for å gjennomføre betalingen må du begynne på nytt',
            newPaymentButton: 'Begynn på nytt',
            fee: 'Gebyret er',
            feeMessage: 'og blir delt mellom betaler og mottaker',
            feeDescription: 'Gebyret for utenlandsbetaling blir {}',
            validationError: 'Vi kunne ikke hente gebyrene for betalingen, men betalingen kan fortsatt gjennomføres.',
            paymentPeriod:
                'Mottaker får vanligvis pengene innen 1-2 dager. For land i andre tidssoner kan det ta lenger tid',
            blockedErrorMessage: 'Betalingen kan dessverre ikke gjennomføres',
            invalidAccountNumber: 'Ugyldig kontonummer til mottaker',
        },
        invalidCurrency: 'Ugyldig valuta',
    },
    currencyField: {
        label: 'Valuta',
        searchPlaceholder: 'Søk etter valuta',
        title: 'Overføringsvaluta',
        description: 'Velg hvilken valuta du ønsker skal bli trukket fra kontoen din',
        recommended: 'Anbefalt',
        allCurrency: 'Alle valuta',
        transferCurrencyDescription:
            'Du har valgt en annen valuta enn banken kan motta. Du må derfor velge en overføringsvaluta.',
        transferCurrencySubTitle: 'Velg overføringsvaluta',
        errorTransferCurrency:
            'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å hente listen med valuta',
        missingTransferCurrency: 'Du må velge en overføringsvaluta',
    },
    chargeBearerField: {
        title: 'Omkostninger',
        description:
            'Det er vanlig å dele på kostnadene ved utenlandsbetaling. Det betyr at du som avsender betaler i din bank og mottaker betaler eventuell kostnad i sin bank.',
        infoMessage:
            'Merk at vi ikke kjenner til omkostningene i mottakers bank. Prisene for utenlandsbetaling finner du i prislisten.',
    },
    chargeBearerOptions: {
        SHARED: 'Delt',
        SENDER: 'Du betaler',
        RECEIVER: 'Mottaker betaler',
    },
    chargeBearerFeeDescription: {
        SHARED: 'delt mellom deg og mottaker',
        SENDER: 'betalt av deg',
        RECEIVER: 'betalt av mottaker',
    },
    chargeBearerSelectOptions: {
        SHARED: 'Delte omkostninger',
        SENDER: 'Du betaler omkostningene',
        RECEIVER: 'Mottaker betaler omkostningene',
    },
    delete: 'Slett',
    details: 'Detaljer',
    disableAvtaleGiroChanges: {
        changeAndDeleteUnavailable: 'Det er dessverre ikke mulig å slette eller endre på AvtaleGiro for øyeblikket.',
        creationUnavailableTitle: 'Vi beklager',
        creationUnavailableDescription: 'Det er dessverre ikke mulig å opprette AvtaleGiro for øyeblikket.',
    },
    confirmDelete: 'Ja, slett',
    date: 'Dato',
    editDisplayAndOrderOfAccounts: 'Endre visning og rekkefølge på kontoer',
    editAccounts: {
        view: 'Rediger kontovisning',
        info: 'Merk kontoene du ønsker å se på forsiden, og hold og dra på kontoene for å endre rekkefølge. Du kan også bruke pilene. Rekkefølgen vil gjelde alle steder hvor kontoene dine listes ut.',
        header: 'Kontovisning',
        addNewGroup: 'Lag ny gruppe',
        remove: 'Slett',
        change: 'Endre',
        confirm: 'Ferdig',
        moveUp: 'flytt opp',
        moveDown: 'flytt ned',
        technicalError: 'teknisk feil',
        errorNotSaved:
            'Vi beklager, det skjedde en feil så noen av endringene dine ble ikke lagret. Prøv igjen litt senere.',
        accountsError:
            'Vi beklager, det skjedde en feil så du kan ikke endre visning og rekkefølge på kontoene dine akkurat nå. Prøv igjen litt senere.',
        cantDisable: 'Du må vise minst en konto på forsiden.',
        success: 'Kontolisten er oppdatert',
        newGroupName: 'Ny gruppe',
    },
    eFaktura: {
        eFaktura: 'eFaktura',
        eFakturaApproved: 'eFaktura er godkjent',
        eFakturaChangedDate: 'Dato på eFaktura endres til i dag',
        eFakturaError: 'Vi beklager, noe gikk galt. Prøv igjen senere',
        eFakturaIcon: 'eFaktura-ikon',
        isDeleted: 'eFaktura er slettet',
        seeAll: 'Se alle eFaktura',
        sureYouWantToDelete: 'Er du sikker på at du vil slette denne eFakturaen?',
        willBeDeletedInAllBanks: 'eFakturaen vil slettes i alle banker',
        noValidFromAccounts: 'Du har ikke en konto som du kan betale eFaktura fra.',
        allEFakturasApproved: 'Bra jobbet! Du har godkjent alle eFaktura',
        approve: 'Godkjenn',
        eFakturaInvalidAccount: 'Du må ha brukskonto for å betale eFaktura',
        missingKidIssue:
            'eFaktura uten KID blir ikke markert som betalt, sjekk fremtidige betalinger dersom du er i tvil. Vi jobber med en løsning.',
        emptyList: 'Du har ingen flere betalinger til godkjenning',
        notice: {
            EFAKTURA: undefined,
            EFAKTURA_WITH_AVTALEGIRO: 'Denne betalingen blir automatisk trukket som en AvtaleGiro',
            REMINDER: 'Vær oppmerksom på at dette er en purring. Hvis du allerede har betalt kan du slette denne.',
            ENFORCEMENT_WARNING:
                'Vær oppmerksom på at dette er et varsel om at betalingen oversendes namsmann. Hvis du allerede har betalt kan du slette denne.',
            COLLECTION_NOTICE:
                'Vær oppmerksom på at dette er et inkassovarsel. Hvis du allerede har betalt kan du slette denne.',
            CREDIT_NOTE: 'Dette er et varsel om tilbakebetaling. Denne skal ikke betales',
            DUNNING: 'Vær oppmerksom på at dette er en purring. Hvis du allerede har betalt kan du slette denne.',
            PAYMENT_REQUEST:
                'Vær oppmerksom på at dette er en purring på inkasso. Hvis Hvis du allerede har betalt kan du slette denne.',
        },
        confirmPayment: 'Ja, betal',
        confirmationDialogTitle: 'Er du sikker på at du vil betale denne delte eFakturaen?',
        nextEFaktura: 'Neste eFaktura',
        previousEFaktura: 'Forrige eFaktura',
        delete: 'Slett',
    },
    eFakturaAgreement: {
        title: 'eFaktura',
        jttaTitle: 'eFaktura',
        jttaDescription:
            'Med eFaktura mottar du regningene digitalt, uansett hvor du er. Du har full kontroll og oversikt til enhver tid.',
        jttaAriaLabel: 'Ja takk til alle eFaktura',
        dialogTitle: 'Er du sikker på at du vil skru av eFaktura?',
        dialogDescription:
            'Vær oppmerksom på at du ikke lenger vil motta eFaktura fra noen leverandører. Regninger kan bli sendt i posten, epost, eller digipost i stedet.',
        dialogConfirmation: 'Ja',
        warningMessage: 'Vi har dessverre noen utfordringer på eFaktura akkurat nå. Prøv igjen litt senere.',
        errorLabel: 'Ojsann, noe gikk galt! Prøv igjen litt senere. Kontakt oss hvis feilen vedvarer.',
        noAgreementTitle: 'Kom i gang med eFaktura',
        noAgreementDescription: 'For å motta eFaktura automatisk må du oppgi e-postadresse og telefonnummer*',
        missingContactDescription:
            'For å få eFaktura må du bekrefte dine kontaktopplysninger slik at vi kan sende deg varsler om ubetalte eFaktura.*',
        noAgreementCaption:
            '*Dette vil deles med Mastercard Payment Services slik at du kan motta varslinger om eFaktura',
        createAgreement: 'Kom i gang',
        emailValidation: 'E-postadressen er ikke gyldig',
        emailRequired: 'Du må fylle inn e-postadresse',
        mobilNumberRequired: 'Du må fylle inn mobilnummer',
        mobileNumberNotValid: 'Mobilnummeret er ikke gyldig',
        emailField: {
            label: 'E-post',
            placeholder: 'Legg til e-postadresse',
        },
        mobileNumberField: {
            label: 'Mobilnummer',
            placeholder: 'Legg til mobilnummer',
        },
        update: 'Oppdater',
        historyLink: 'Historikk',
        reservationsLink: 'Reservasjoner',
        notificationsLink: 'eFaktura-varslinger',
        archiveLink: 'eFaktura arkiv',
    },
    eFakturaHistory: {
        title: 'eFaktura historikk',
        description: 'Her finner du en oversikt over hvem du har fått eFaktura fra de siste 16 månedene.',
        error: 'Vi beklager, vi kunne ikke hente eFaktura historikken din på grunn av en teknisk feil.',
        noCreditors: 'Her har det ikke skjedd så mye!',
    },
    eFakturaNotifications: {
        toggleEmailLabel: ' Få varslinger på epost',
        off: 'Av',
        noAgreementInfo: 'For å få varslinger på epost må du gå tilbake og skru på alltid eFaktura.',
        goBack: 'Gå tilbake',
        differentEmailWarning: {
            header: 'Obs!',
            text: 'Denne adressen er annerledes enn den du har satt under Kontaktinfo og ID. Denne epostadressen vil kun gjelde eFaktura-varslinger.',
            linkText: 'Til Kontaktinfo og ID',
        },
    },
    eFakturaReservation: {
        title: 'Reserver deg mot eFaktura',
        description:
            'Her kan du reservere deg mot eFaktura fra ulike bedrifter du har mottatt eFaktura fra de siste 16 månedene.',
        error: 'Det har skjedd en teknisk feil som gjør at det ikke er mulig å legge inn eller se reservasjoner akkurat nå.',
        noCreditors: 'Du har ingen bedrifter du kan reservere deg mot',
        searchCreditor: 'Søk etter bedrift',
        noBlockedCreditors: 'Du har ikke reservert deg mot å få eFaktura fra noen',
        yourReservations: 'Dine reservasjoner',
        unblockError: 'Det har skjedd en teknisk feil, så vi klarte ikke å slette reservasjonen.',
        confirmUnblock: 'Er du sikker på at du vil slette reservasjonen?',
        blockSuccess: 'Reservasjon mot eFaktura fra {} er lagt til!',
        blockError: 'På grunn av en teknisk feil klarte vi ikke å legge inn reservasjonen.',
        youChose: 'Du har valgt:',
        blockDescription:
            'Etter at du har reservert deg, vil {} ikke kunne sende deg eFaktura lenger. Da kan faktura bli sendt i posten, epost eller digipost.',
        confirmBlock: 'Reserver deg',
    },
    eFakturaAccount: {
        title: 'Velg betalingskonto for eFaktura',
        description: 'Du kan når som helst endre betalingskonto hvis du vil bytte til en annen konto.',
        label: 'Betalingskonto',
        success: 'Betalingskonto for eFaktura er valgt',
        chosenEFakturaAccount: 'Du har valgt {} som betalingskonto',
        error: 'eFaktura-konto ble dessverre ikke lagt til, vennligst prøv igjen',
        notSetTitle: 'Ingen valgt betalingskonto',
        notSetDescription: 'Ønsker ikke å ha en fast betalingskonto for eFaktura',
        unselectedSuccess: 'Betalingskonto er ikke satt',
        noAccountsTitle: 'Du trenger en konto for å velge betalingkonto',
        noAccountsText1: 'Du har ingen kontoer ennå. Dette trenger du for å kunne velge en spesifikk betalingskonto.',
        noAccountsText2: 'Vises ikke kontoene dine, er feilen på vår side. Forsøk gjerne igjen om en time.',
    },
    eFakturaSharing: {
        shareEfaktura: 'Del eFaktura',
        giveAnotherCustomerAccess: 'Gi en annen kunde tilgang til dine eFaktura',
        shareYourEfaktura: 'Del dine eFaktura',
        sharingWithNobody: 'Du deler ikke eFaktura med noen ennå',
        sharingWith: 'Deler med',
        sharingWithPlaceholder: 'Delt med {}',
        andMore: 'og flere...',
        sharingWithYou: 'Deler med deg',
        whoDoYouWantToShareWith: 'Hvem ønsker du å dele med?',
        name: 'Fornavn og etternavn',
        writeName: 'Skriv fullt navn',
        ssn: 'Fødselsnummer',
        writeSSN: '11 siffer',
        howManyEfakturasToShare: 'Hvor mange eFaktura ønsker du å dele?',
        amountSelected: {
            all: 'Alle',
            some: 'Kun noen',
        },
        chooseEfakturasToShare: 'Velg eFaktura som skal deles',
        noEfakturas:
            'Du har ingen eFaktura-avtaler per i dag. Vi velger derfor "Alle" for deg, slik alle fremtidige avtaler blir valgt.',
        userAlreadyInGiven: 'Du har allerede delt eFaktura med denne kunden, vil du heller endre hva du deler?',
        editSharing: 'Endre delingsavtalen',
        deleteSharing: 'Slett deling',
        errorFetchingEfaktura:
            'Noe gikk galt ved henting av eFaktura-avtaler. Vi velger derfor “Alle” for deg, slik at alle fremtidige avtaler blir delt. Du kan også forsøke på nytt.',
        allEfaktura: 'Alle eFaktura',
        confirmDelete: 'Er du sikker på at du vil slette delingsavtalen med {}?',
        confirmDeleteDescription: 'Sletting er permanent og du kan ikke angre.',
        receiverDeleted: 'Delingsavtalen er slettet',
        userNotFound: 'Vi fant ikke brukeren du leter etter. Kontakt oss hvis feilen vedvarer.',
        chooseFromCompanies: 'Velg fra bedrifter som har sendt deg eFaktura tidligere.',
        orgNumber: 'Org nr {}',
        shortSummary: 'Kort oppsummert',
        confirmationText: {
            all: 'Du gir {} tilgang til alle eFakturaene dine',
            some: 'Du gir {} tilgang til eFaktura fra disse bedriftene:',
        },
        organisationNumber: 'Organisasjonsnummer',
        deleteCompanyFromShareList: 'Slett {} fra delelisten',
        summaryNotice: 'Merk at det kan ta 1 - 2 virkedager før eFaktura deles.',
        giveAccess: 'Gi tilgang',
        validationErrors: {
            userNotFound: 'Ugyldig bruker',
            ssn: {
                invalidLength: 'Fødselsnummeret må være 11 siffer langt',
                NaN: 'Fødselsnummeret må bare være tall',
            },
            name: {
                required: 'Skriv inn fullt navn',
                error: {
                    NOT_FOUND: 'Fant ikke kunden. Merk: dere må ha samme bank.',
                    SAME_PERSON: 'Du har søkt på deg selv. Du har allerede tilgang til eFakturaen.',
                    INVALID: 'Ugyldig fødselsnummer.',
                    ERROR_OCCURED: 'En feil oppstod. Prøv på nytt.',
                },
            },
            amountSelected: {
                required: 'Du må velge en av alternativene',
                alreadySharedEverything: 'Du har allerede delt alle eFaktura med denne kunden.',
            },
            selected: {
                tooFewSelected: 'Du må velge minst en eFaktura å dele',
            },
        },
        noSharedEfakturaInfo: {
            header: 'Her var det tomt',
            noReceivedBody: 'Det er visst ingen eFaktura som er delt med deg',
            noGivenBody: 'Du deler ikke eFaktura med noen ennå',
        },
    },
    eFakturaEmpty: {
        title: 'Her er det helt tomt',
        description: 'Det er ingen eFaktura som trenger godkjenning akkurat nå.',
        link: 'Til forsiden',
    },
    effectiveInterestInfo: {
        title: 'Hvordan beregnes effektiv rente?',
        description1:
            'Effektiv rente viser den totale kostnaden for lånet. Ved beregning inkluderer den kjente kostnader tilbake i tid og frem i tid for nominell rente, etableringskostnader og termingebyrer.',
        description2:
            'Det betyr at fremtidige renteendringer som er varslet, men ikke har trådt i kraft også er inkludert i beregningen. Renten kan derfor i perioder hvor lånerenter går opp eller ned fremstå som kunstig høy eller for lav i forhold til den nominelle renten.',
    },
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        somethingWentWrongFetchingReceivers:
            'Det har skjedd en teknisk feil, så vi klarte ikke å hente mottakerne dine akkurat nå.',
        somethingWentWrongFetchingSomeReceivers: 'Vi klarer ikke å vise mottakere fra {} akkurat nå',
        somethingWentWrongDeletingReceiver: 'Beklager, vi klarte ikke å slette mottakeren',
        somethingWentWrongChangingReceiver: 'Beklager, vi klarte ikke å endre mottakeren',
        avtaleGiroErrorFetchingAccounts:
            'For å opprette en AvtaleGiro trenger du en brukskonto. Dessverre klarer vi ikke å hente kontoene dine akkurat nå.',
        ohNo: 'Å nei!',
        oops: 'Oj sann!',
        sorry: 'Vi beklager!',
        rcid: 'Feilkode',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
    },
    createdBy: 'Opprettet av {}',
    you: 'deg',
    paymentsForApproval: 'Betalinger til godkjenning',
    signAndAddApproval: 'Signer og legg til godkjenning',
    approveAndPay: 'Godkjenn og betal',
    needsAdditionalApproval:
        'Betalingen må godkjennes av andre. Legg til godkjenning om du ønsker å samle opp betalinger før du signerer.',
    outbox: {
        approvePayment: 'Godkjenn betaling',
        removeApproval: 'Fjern godkjenning',
        paymentsYouCanSignDomestic: 'Betalinger du kan signere',
        paymentsYouCanSignCrossBorder: 'Utenlandsbetalinger du kan signere',
        paymentsOthersMustSign: 'Betalinger andre må signere',
        mainPageLink: 'Gå til forsiden',
        deleteApprovalItemFailed:
            'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble slettet før du prøver på nytt.',
        deleteApprovalItemSuccess: 'Betalingen er fjernet',
        unapproveItemFailed:
            'Vi beklager, dette gikk ikke helt etter planen. Sjekk om godkjenningen ble fjernet fra betalingen før du prøver på nytt.',
        unapproveItemSuccess: 'Godkjenningen ble fjernet',
        confirmUnapprove: 'Ja, fjern godkjenning',
        emptyList: 'Du har ingen betalinger som krever godkjenning',
        dateSetToToday: 'Betalingen settes til dagens dato',
        edit: 'Endre',
        editOrDelete: 'Endre eller slett',
        editSuccess: 'Betalingen er endret!',
        retryEdit: 'Ja, fortsett',
        editPayment: 'Endre betaling',
        deleteError: 'Vi klarte ikke å slette betalingen akkurat nå. Prøv igjen nå, eller forsøk igjen litt senere.',
        editError: 'Vi klarte ikke å endre betalingen. Prøv på nytt nå, eller forsøk igjen litt senere.',
        errorContactUs: 'Kontakt oss hvis problemet vedvarer.',
        saveChanges: 'Lagre endringer',
        delete: 'Slett',
        deletePayment: 'Slett betaling',
        checkboxLabel: 'Hak av for å legge i betalingsliste',
        waitingForNrOfSignings: 'Venter på {} godkjenninger',
        youHaveApproved: 'Du har godkjent betalingen',
        plannedPaid: 'Planlagt betalt',
        totalForOthersApproval: 'Totalt til andres godkjenning {}',
        totalForYourSigning: 'Totalt til din godkjenning {}',
        noSelectedPayments: 'Du må velge minst én betaling',
        paidBy: 'Betalt av {}',
        removeChosen: 'Fjern valgte',
        chooseAll: 'Velg alle',
    },
    approveAll: 'Godkjenn alle',
    approveAllPaymentLimitValidation:
        'Maksgrense for betalinger er {} kr i måneden, med disse betalingene går du {} kr over maksgrensen din. For å gå videre må du endre på en eller flere av betalingene eller beløpsgrensen din',
    forceUpdateModal: {
        title: 'Mobilbanken må oppdateres',
        description: 'Du må oppdatere til siste versjon for å fortsatt benytte mobilbanken.',
        buttonText: 'Oppdater nå',
    },
    from: 'Fra',
    futurePaymentDetails: {
        fakedLoanPayment: {
            warning: 'Dette er en forventet nedbetaling på lånet ditt. Det er ikke mulig å endre eller slette denne.',
        },
        normal: {
            noEditWarning: 'Denne betalingen kan dessverre ikke endres.',
        },
        foreignPayment: {
            noEditWarning:
                'Det er dessverre ikke mulig å endre en fremtidig utenlandsbetaling. Hvis noe ikke er riktig, må du slette betalingen og opprette den på nytt.',
        },
        recurringPayment: {
            editLink: 'Endre betaling',
            editWarning:
                'Du kan ikke endre faste betalinger her enda. Det kan endres fra oversikt over faste betalinger.',
        },
        noReject: {
            editWarning:
                'Denne betalingen er det ikke mulig å slette eller endre. Kontakt banken for hjelp til å slette denne betalingen.',
        },
        calculatedAmount: 'Foreløpig beregnet beløp',
        amountInCurrency: 'Beløp i transaksjonsvaluta',
        paidBy: 'Betalt av',
        change: 'Endre',
    },
    futurePayments: {
        balanceToday: 'Saldo i dag ',
        noFuturePayments: 'Du har ingen fremtidige betalinger på',
        thisAccount: 'denne kontoen',
        rightNow: 'akkurat nå.',
        infoMessage: 'Viser for de neste 45 dagene',
        infoAvtalegiroText:
            'Hvis du vil endre på en AvtaleGiro, fast betaling eller overføring må du gjøre det på selve avtalen.',
        infoAvtalegiroLink: 'Administrer betalinger',
        warningBMMissingFilesText:
            'Noen betalinger kan mangle i denne listen. Disse finner du i liten over betalinger.',
        warningBMMissingFilesLink: 'Gå til fullstendig liste',
        paidBy: 'Betalt av {}',
        approvedBy: 'Godkjent av {}, {}',
    },
    futurePaymentsList: {
        ariaLabel: 'Filtrer fremtidige betalinger',
        totalIn: 'Totalt inn',
        totalOut: 'Totalt ut',
        title: 'Fremtidige betalinger',
        future: 'Fremtidige',
        payment: 'betaling',
        payments: 'betalinger',
        paymentsLeftThisMonth: '{} {} igjen neste 30 dager',
        removeAllSelected: 'Nullstill',
        selectAll: 'Velg alle',
        removeChosenAccounts: 'fjern filter: ',
        chooseAccount: 'Velg konto',
        chosenAccount: '{} valgt konto',
        chosenAccounts: '{} valgte kontoer',
        choose: 'Velg',
        total: 'Til sammen {}',
        noHits: 'Fant ingen fremtidige betalinger',
        couldNotGetFuturePayments: 'Vi beklager, vi kunne ikke hente dine fremtidige betalinger pga teknisk feil',
    },
    futurePaymentsEFaktura: {
        it: 'Den',
        theFirst: 'Den første',
        hasDeadlineToday: 'har frist i dag',
        hasDeadlineTomorrow: 'har frist i morgen',
        hasDeadlineOn: 'har frist på',
        hasDeadline: 'har frist',
        hadDeadlineYesterday: 'hadde frist i går',
        hadDeadlineLast: 'hadde frist forrige',
        hadDeadline: 'hadde frist',
        youHave: 'Du har',
        newSingular: 'ny',
        newPlural: 'nye',
    },
    paymentItemStatus: {
        WAITING_FOR_SIGNING: 'Trenger godkjenning',
        STOPPED: 'Stoppet betaling',
        REJECTED: 'Avvist betaling',
        EXPIRED: 'Utløpt betaling',
        PENDING_PAYMENT: 'Til betaling',
        UNKNOWN: '',
    },
    paymentSubStatus: {
        EXCEEDING_MAX_LIMIT: 'Betalingen overskrider beløpsgrensen',
        INSUFFICIENT_ACCESS: 'Ingen tilgang',
        INSUFICIENT_FUNDS: 'Mangler dekning på konto',
        INVALID_CID: 'Ugyldig KID nummer',
        STOPPED_BY_USER: 'Stoppet av bruker',
        CANCELLED_BY_BANK: 'Stoppet av banken',
        CANCELLED_BY_USER: 'Stoppet av bruker',
    },
    insufficientFundsFromOwnAccount: 'Mangler dekning på avsenderkonto',
    futurePaymentType: {
        TRANSFER: 'Overføring',
        PAYMENT: 'Betaling',
        FOREIGN_PAYMENT: 'Utenlandsbetaling',
        RECURRING_PAYMENT: 'Fast betaling',
        RECURRING_TRANSFER: 'Fast overføring',
        AUTO_PAYMENT: 'AvtaleGiro',
        EFAKTURA: 'eFaktura',
        UNKNOWN: '',
    },
    futurePaymentOwnerSuffix: 'sin konto',
    stopFuturePayment: {
        delete: 'Slett',
        confirm: 'Ja, slett',
        cancel: 'Avbryt',
        header: 'Er du sikker på at du vil slette denne {}?',
        headerParamTransfer: 'overføringen',
        headerParamPayment: 'betalingen',
        headerParamEFaktura: 'eFakturaen',
    },
    futurePaymentsInfoCardTitle: 'Du har ingen fremtidige betalinger akkurat nå.',
    futurePaymentsErrorMessage:
        'Vi beklager, vi det har skjedd en teknisk feil så du kan ikke sjekke fremtidige betalinger akkurat nå. Prøv igjen litt senere.',
    futurePaymentTitle: {
        eFaktura: 'eFaktura',
        payment: 'Betaling',
        transfer: 'Overføring',
    },
    immediatePayment: {
        title: 'Straksbetaling',
        info: 'Med straksbetaling kommer pengene på konto til mottaker i løpet av få sekunder.',
        priceInfo: 'Vær oppmerksom på at det kan tilkomme gebyr ved straksbetaling',
        priceButton: 'Se våre prislister',
        stepUpRequired: {
            title: 'Økt sikkerhet',
            text1: 'Straksbetaling krever høy sikkerhet. For å gjennomføre betalingen ønsker vi å gjøre en bildeverifisering av deg. Det går raskt, og når du er ferdig så åpner vi samtidig opp mer funksjonalitet for deg i mobilbanken. ',
            text2: 'NB! Når du er verifisert må du starte betalingsprosessen på nytt.',
            text3: 'Du kan velge å betale på vanlig måte. Da vil betalingen gå litt saktere og det vil ta noe lengre tid før mottaker får pengene på kontoen.',
            start: 'Få full tilgang',
            back: 'Legg til som normal betaling',
        },
    },
    invalidMessage: 'Denne meldingen er ikke gyldig.',
    isPaidFrom: 'Betales fra',
    keepAlive: {
        title: 'Er du der?',
        description: 'Av hensyn til din sikkerhet sjekker vi om du fortsatt er her etter en viss tid.',
        confirmationButtonText: 'Ja, jeg er her',
    },
    lastLogin: 'Sist innlogget',
    loanAccount: 'lånekonto',
    loanDetails: {
        error: 'Vi beklager, vi kunne ikke hente lånedetaljene dine på grunn av en teknisk feil',
        header: 'Lånedetaljer',
        nameOfLoan: 'Navn på lån',
        loanOwners: 'Låntakere',
        ownerOfLoan: 'Eier av lån',
        coOwner: 'Medlåntaker',
        noLoan: 'Fant ikke lån',
        interest: 'Rente',
        paymentPlanMessage: 'Nedbetalingsplan for lån er ikke på plass enda, vi jobber med saken.',
        dueDay: 'Trekkdato',
        endDate: 'Nedbetalt dato',
        principal: 'Opprinnelig lånebeløp',
        balance: 'Resterende lån',
        administrationFee: 'Administrasjonsgebyr',
        everyMonth: '{}. hver måned',
        effectiveInterest: 'Effektiv rente {} %',
        nominalInterst: 'Nominell rente',
        amount: 'Beløp',
        nextPayment: 'Neste innbetaling',
        initialAmount: 'Opprinnelig lånebeløp',
        plannedDownpaymentDate: 'Nedbetalt dato',
        debitAccount: 'Belastningskonto',
        downpaymentDay: 'Trekkdato',
        installmentAmount: 'Terminbeløp',
        editPaymentDateAndPaymentAccount: 'Endre trekkdato og betalingskonto her',
        seeDetails: 'Se lånedetaljer',
        moreInformationAboutThisLoan: 'Mer informasjon om dette lånet',
    },
    downpayment: {
        cannotDoDownpayment: 'Du kan ikke gjøre en ekstra innebetaling for et fastrente lån.',
        noTransferFromAccount: 'Du har ingen konto du kan gjøre denne nedbetalingen fra.',
    },
    loanDownpaid: 'Lånet er nedbetalt.',
    loanError: 'Vi beklager, vi kunne ikke hente lånet ditt på grunn av en teknisk feil.',
    loanOwners: 'Låneeiere',
    loanName: 'Lånenavn',
    loanOverviewErrorMessage: 'Det har skjedd en teknisk feil, så det kan hende noen av lånene dine ikke vises.',
    loanOverviewNoLoansHeader: 'Du har ingen lån hos oss',
    loanOverviewNoLoansText: 'Livet forandrer seg - og det gjør lånebehovene dine også. Vi er her for å hjelpe deg.',
    loanRepaymentPlan: {
        viewRepaymentPlan: 'Se nedbetalingsplan',
        error: 'Vi beklager, vi kunne ikke hente nedbetalingsplan på grunn av en teknisk feil',
        period: 'Periode',
        youPay: 'Du betaler',
        instalment: 'Avdrag',
        charges: 'Gebyr',
        interest: 'Renter',
        balance: 'Resterende lån',
    },
    loanEdit: {
        edit: 'Administrer lånet',
        editAccountToPayFrom: 'Endre konto å betale fra',
        editDebitAccount: 'Endre trekkonto',
        chooseDebitAccount: 'Velg kontoen lånet skal trekkes fra',
        dayEachMonth: 'Den {}. hver måned',
        dayEachYear: 'Den {}. hvert år',
        dayEachHalfYear: 'Den {}. hvert halvår',
        dayEachCustom: 'Den {}. hver {}. dag',
        editDay: 'Endre trekkdato',
        chooseDay: 'Velg dagen du ønsker at lånet skal bli trukket',
        save: 'Lagre',
        everyDay: ' hver dag',
        dayPrefix: 'Den',
        onlyFutureDates:
            'Fordi lånet ikke allerede er sendt til betaling denne måneden, er det kun mulig å velge trekkdato minimum en dag fram i tid.',
        editInfoMessage: 'Husk at når du endrer trekkdato, vil neste betaling ta hensyn til endret renteberegning.',
        cantBeChanged: 'Lånetrekket er for nærme forfall og kan ikke endres før etter forfall',
        errors: {
            debitAccountDefaultError:
                'Vi beklager, vi kunne ikke endre trekkonto for lånet ditt på grunn av en teknisk feil.',
            paymentDayDefaultError:
                'Vi beklager, vi kunne ikke endre trekkdato for lånet ditt på grunn av en teknisk feil.',
            dayBiggerThanOrLessThan: 'Trekkdato må være større enn {} og {} eller mindre',
            mustChooseDate: 'Du må velge en trekkdato',
            alreadyChosen: 'Denne datoen er allerede valgt',
            biggerThan: 'Trekkdato må være større enn {}',
            biggerThanAndNotPaid:
                'Du må velge en trekkdato 5 dager fra idag, fordi lånet ikke er trukket denne måneden',
            lessThan: 'Trekkdato må være {} eller mindre',
        },
    },
    logout: 'Logg ut',
    login: {
        toggleBiometrics: 'Innlogging og signering med {}',
        biometricsError: 'Vi beklager, noe gikk galt. Prøv igjen senere',
        changeBank: 'Endre hovedbank',
        changeBankAndAgreement: 'Endre hovedbank/hovedavtale',
        changeAgreement: 'Endre hovedavtale',
        myActivations: 'Mine enheter',
        loginAndSigning: 'Innlogging- og signeringsmetode',
        signingAndLoginChoice: '{} er valgt for innlogging og signering.',
        signingAndLoginChoiceDifferent: 'Du logger inn med {} og signerer med {}',
        stepUp: {
            title: 'Økt sikkerhet',
            description:
                'Få full tilgang til alle dagens og kommende funksjoner i mobilbanken ved å gjøre en rask bildegjenkjenning',
        },
    },
    loginAndSigning: {
        chooseLoginMethodDescription:
            'Velg hvordan du ønsker å logge deg inn. PIN-koden lagde du ved aktivering av mobilbanken. Da fikk du også valget om biometrisk pålogging.',
        chooseSigningMethodDescription:
            'Velg hvordan du ønsker å signere for å godkjenne betalinger og lignende i mobilbanken.',
        step: 'Steg {} av 2',
        chooseSigningMethodTitle: 'Velg signeringsmetode',
        chooseLogin: 'Velg innlogginsmetode',
        toFrontPage: 'Til forsiden',
        back: 'Tilbake',
        headerSuccess: 'Signerings- og innlogginsmetode er satt!',
        saveAndComplete: 'Lagre og fullfør',
        saveAndContinue: 'Lagre og gå videre',
        errorMessageBiometryDisabled: 'For å velge biometri må det være skrudd på i innstillinger på telefonen',
        infoMessageEnableBiometry:
            'For å kunne velge å signere med biometri, må du også ha biometrisk innlogging. Endres i forrige steg.',
        signingMethods: {
            PIN: 'PIN-kode',
            BANKID: 'BankID',
            BIOMETRIC: 'Biometri',
        },
        errorMessageSigningMethod: 'Signeringsmetoden kunne ikke lagres på grunn av en teknisk feil.',
        errorMessageNoSigningMethodChosen: 'Du må velge en signeringsmetode for å fullføre',
        errorMessageNoLoginMethodChosen: 'Du må velge en innlogingsmetode for å gå videre',
        errorMessage: 'Vi beklager, noe gikk galt. Prøv igjen senere',
    },
    kidNumber: 'KID',
    notEnoughInAccount: 'Det er ikke nok penger på kontoen',
    new: 'NY',
    next: 'Neste',
    ok: 'OK',
    payment: 'Betal',
    payNow: 'Betal nå',
    transferNow: 'Overfør nå',
    addPaymentForApproval: 'Legg til godkjenning',
    paymentForApproval: 'Betaling ble lagt til godkjenning',
    applyForAvdragsfrihet: 'Søk om avdragsfrihet',
    previous: 'Forrige',
    paymentSettings: {
        eFaktura: 'eFaktura',
        avtaleGiro: 'AvtaleGiro',
        addAndEditAgreements: 'Legg til og endre avtalene dine',
        accountView: 'Kontovisning',
        editAccountView: 'Endre kontovisning',
        paymentLimits: 'Beløpsgrenser',
        editPaymentLimits: 'Endre beløpsgrenser',
    },
    payWithBankId: 'Betal',
    priorityField: {
        title: 'Velg prioritet',
        label: 'Prioritet',
        description:
            'Betalinger merket “haster” vil få dagens vekslingskurs og normalt være på mottakers konto samme eller neste dag. Ekstra kostnader kan forekomme.',
    },
    priorityOption: {
        STANDARD: 'Normal',
        URGENT: 'Haster',
    },
    pushNotifications: {
        label: 'Pushvarslinger',
        mainSwitch: 'Hovedbryter',
        error: 'Vi klarte ikke å skru på varslinger akkurat nå',
        errorFetchRules: 'Noe gikk galt ved innhenting av pushvarslinger.',
        errorRetry: 'Prøv igjen',
        errorDeactivate: 'Vi klarte ikke å skru av varslinger akkurat nå',
        errorToggleRule: 'Det har oppstått en feil, og det er ikke mulig å endre varselet akkurat nå.',
        chooseNotificationsToGet: 'Velg hvilke varslinger du vil få',
        soonMessage: 'Snart kan du selv velge å aktivere enda flere varslinger.',
        infoMessage:
            'Når du har aktivert pushvarslinger, kan du tilpasse under hvilke kategorier du ønsker å motta varslinger om.',
        gdprTitle: 'Personvern',
        gdprDescription:
            'Pushvarslinger gir deg beskjed når det skjer noe viktig og er helt gratis. Du har full kontroll og kan når som helst skru av varslingene her, under {}.\n' +
            '\n' +
            'For å kunne sende deg pushvarslinger lagrer vi fødselsnummer og hvilken mobiltelefon du har.\n' +
            'Dette er nødvendig for å kunne benytte seg av tjenesten. Opplysningene slettes når du deaktiverer Pushvarslinger.',
        location: 'Profil og innstillinger > Pushvarslinger',
        category: {
            efaktura: 'eFaktura',
            messages: 'Meldinger',
            account: 'Konto',
            loan: 'Lån',
            payments: 'Betalinger',
        },
        toggleLabel: {
            EFAKTURA_EVENT: 'Ny eFaktura',
            EFAKTURA_WITH_AVTALEGIRO_EVENT: 'Ny eFaktura med AvtaleGiro',
            SHARED_EFAKTURA_EVENT: 'Når noen deler en eFaktura med deg',
            MESSAGE_EVENT: 'Melding fra rådgiver',
            SHARED_ACCOUNT: 'Når noen deler en konto med deg',
            LOAN_APPLICATION_EVENT: 'Varsel om statusendring i din lånesøknad',
            OVERDUE_EFAKTURA_EVENT: 'Manglende godkjenning av efaktura',
            STOPPED_PAYMENT_EVENT: 'Når en betaling stoppes',
            STUDENT_LOAN_CONSENT_EVENT: 'Når samtykket på studielånet ditt går ut',
            salary: 'Når du får lønn på konto',
            account: 'Når beløp på konto går under satt verdi',
            UNKNOWN: 'N/A',
        },
        accountSpecificNotifications: {
            BALANCE_LESS_THAN: { title: 'Saldo under valgt beløp', text: 'Når saldo på {} går under {}' },
            DEPOSIT_MORE_THAN: {
                title: 'Innbetaling større enn valgt beløp',
                text: 'Når {} får innbetalt beløp over {}',
            },
        },
        chooseAccountHere: 'Velg konto her',
        account: {
            customNotifications: 'Egendefinerte regler',
            createNotificationRule: 'Opprett ny regel',
            chooseNotificationType: 'Velg en varseltype',
            chooseAccount: 'Velg konto',
            noAccountsToChooseFrom: 'Ingen mulige kontoer',
            youHaveNoMoreAccountsToAddThisNotificationTo: 'Du har ingen flere kontoer å legge til denne varseltypen på',
            chooseAmount: 'Sett ett beløp',
            errorCreatingNotification: 'Det har oppstått en feil, og det er ikke mulig å opprette varselet akkurat nå.',
            createNotification: 'Opprett varsel',
            couldNotGetNotificationsForAccount: 'Vi kunne ikke hente inn varslinger for konto',
            amountError: 'Beløpet kan ikke være høyere enn: {}',
        },
        deleteFlow: {
            areYouSure: 'Er du sikker på du vil slette dette varselet',
            deleteNotification: 'Slett varsel',
        },
        salary: {
            title: 'Lønn',
            tryingToChangeChosenAccount: 'Forsøker å endre valg konto',
            editFailed: 'Endringen feilet',
            accountChanged: 'Konto endret',
            chooseSalaryAccount: 'Velg lønnskonto',
        },
        couldNotGetNotificationsFor: 'Vi kunne ikke hente inn varslinger for {}',
    },
    reserved: 'Reservert',
    expectedBookBalanceDate: 'Forventet oppdatert',
    amountNotAvailableWithDate:
        'Denne transaksjonen er reservert på din konto, og vil bli gjennomført ved neste bankkjøring. Merk at det kan ta opp til et døgn før du ser komplette transaksjonsdetaljer',
    receiverTypes: {
        receiver: 'Norge',
        crossBorderReceiver: 'utlandet',
    },
    receipt: {
        title: 'Kvittering',
        description: 'Vær oppmerksom på at det tilkommer gebyr ved tilsendt kvittering.',
        needReceipt: 'Bestill kvittering',
        receiptType: {
            NONE: 'Ingen',
            STICKER: 'Med oblat',
            PRINT: 'Uten oblat',
        },
        receiptTypeVerbose: {
            NONE: 'Ingen kvittering',
            STICKER: 'Kvittering med oblat',
            PRINT: 'Kvittering uten oblat',
        },
        receiptTypeSimplified: {
            NONE: 'Ingen kvittering',
            STICKER: 'Kvittering med oblat',
            PRINT: 'Kvittering',
        },
    },

    recurringPayments: {
        recurringPayment: 'Fast betaling',
        recurringTransfer: 'Fast overføring',
        newRecurringTranfer: 'Ny fast overføring',
        recurringPayments: 'Faste betalinger',
        newRecurringPayment: 'Ny fast betaling',
        agreements: 'Avtaler',
        skipLink: 'Hopp til opprett fast overføring eller betaling',
        noPayments: 'Du har ingen faste betalinger hos oss',
        errorMessage:
            'Vi beklager, det har skjedd en teknisk feil så du kan ikke sjekke faste betalinger akkurat nå. Prøv igjen litt senere.',
        createPayment: 'Opprett betaling',
        createTransfer: 'Opprett overføring',
        recurringTransferSuccess: 'Fast overføring er opprettet',
        sureYouWantToDelete: 'Er du sikker på at du vil slette denne faste {}en?',
        isDeleted: '{}en er slettet',
        update: 'Oppdater',
        lastDate: 'Siste betalingsdato',
        detailsButton: 'Se/endre avtalen',
        frequency: 'Frekvens',
        nextDate: 'Neste dato',
        amount: 'Beløp',
        endDate: 'Avsluttes {}',
        cantDeleteMessage:
            'Denne betalingen kan ikke slettes her. Kontakt banken for hjelp til å slette denne faste {}en',
    },
    recurringPaymentStatus: {
        ACTIVE: 'Aktiv',
        INACTIVE: 'Avsluttet',
        UNKNOWN: 'Ukjent',
    },
    recurringPaymentType: {
        PAYMENT: 'betaling',
        TRANSFER: 'overføring',
        UNKNOWN: 'ukjent',
    },
    recurringPaymentValidation: {
        success: 'Fast {} er oppdatert',
        error: {
            heading: 'Oj sann!',
            description:
                'Vi beklager, dette gikk ikke helt etter planen. Sjekk om den faste {}en ble oppdatert før du prøver på nytt.',
            check: 'Sjekk avtaler',
        },
        notSigned: {
            heading: 'Oj sann!',
            description: 'Endring av fast {} ble ikke bekreftet, vil du prøve på nytt?',
            tryAgain: 'Prøv på nytt',
            change: 'Endre',
            cancel: 'Avbryt',
        },
    },
    salaryInfo: {
        title: 'Neste lønn',
        editLink: 'Endre Neste lønn',
        error: 'Klarte ikke hente info om neste lønn',
        untilNextSalary: 'til neste lønn',
        payments: 'Betalinger {}',
        left: '{} igjen',
        untilSalary: 'Til lønn',
        daysLeft: ' {} d igjen',
        days: '{} d',
        editSalaryInfoStartPageDescription:
            'Usikker på om du har nok penger til neste lønn? Nå kan du se hvor mye du har igjen på konto frem til neste lønn etter at alle regninger er betalt.',
        edit: {
            description:
                '“Neste lønn” er en beregning av disponibelt beløp minus fremtidige betalinger til neste lønning. Har du innvilget kreditt er den med i beregningen.',
            descriptionGdpr: 'Lønningsdato og valgt konto lagres så lenge du bruker denne løsningen.',
            confirmDelete: 'Er du sikker på at du vil fjerne “Neste lønn” fra forsiden?',
            toFrontpageLink: 'Til forsiden',
            updateSuccess: '“Neste lønn” er oppdatert',
            updateError: '“Neste lønn” ble dessverre ikke oppdatert, vennligst prøv igjen',
            saveSuccess: '“Neste lønn” er lagt til',
            saveError: '“Neste lønn” ble dessverre ikke lagt til, vennligst prøv igjen',
            deleteSuccess: '“Neste lønn” er fjernet fra forsiden',
            deleteError: '“Neste lønn” ble dessverre ikke fjernet fra forsiden, vennligst prøv igjen',
            paydaysError: 'Fyll inn lønningsdato',
            accountError: 'Velg lønningskonto',
            account: {
                placeholder: 'Legg til konto',
                label: 'Konto',
                title: 'Velg konto',
                subtitle: 'Velg hvilken konto du får lønn på',
            },
            paydays: {
                placeholder: 'Legg til lønningsdato',
                label: 'Lønningsdato',
                title: 'Legg til lønningsdato',
                subtitle: 'Velg en eller flere datoer',
                lastDay: 'siste dag',
                lastDayOfMonth: 'Siste dag hver måned',
                eachMonth: 'Den {} hver måned',
                the: 'Den ',
                and: ' og',
            },
        },
    },
    save: 'Lagre',
    showLess: 'Vis mindre',
    showMore: 'Vis mer',
    seeAll: 'Se alle',
    seeAllAccounts: 'Se alle kontoer',
    settingsAccountOrderNeedMoreAccounts: 'Du må ha flere kontoer hos oss for å endre visning og rekkefølge på kontoer',
    settingsAccountFavoriteNeedMoreAccounts: 'For å endre favorittkonto må du ha flere kontoer',
    settingsProfileLinkDescription: 'Profil, samtykke og meldinger',
    to: 'Til',
    settings: {
        pushNotifications: 'Pushvarslinger',
        changeAppIcon: 'Appikon',
        login: 'Innlogging og sikkerhet',
        paymentSettings: 'Betalingsinnstillinger',
        paymentSettingsSubtitle: 'eFaktura, AvtaleGiro og beløpsgrenser',
        nextSalary: 'Neste lønn',
        nextSalarySubtitle: 'Se hva du har igjen etter at alle regninger er betalt',
        aboutApp: 'Om bruk av banken',
        myConsents: 'Samtykker',
        minBolig: 'Min bolig',
        price: 'Priser',
        meMyselfAndI: 'Meg og mitt',
        adaptations: 'Tilpasninger',
        account: 'Konto',
        accountDescription: 'Velg favorittkonto og rekkefølge på kontoer',
        contactInfo: 'Kontaktinfo og legitimering',
        contactInfoBM: 'Bedriftens kontaktinfo',
        language: 'Språk',
        becomeCustomerChild: 'Kundeetablering for barn',
    },
    thirdPartyDependencies: {
        title: 'Våre tredjepartslisenser',
        description: 'Her er en samling av alle relevante lisenser vi benytter oss av i mobilbanken.',
    },
    invalidFromAccount: {
        transferNotPossible: 'Denne kontoen kan du ikke overføre fra',
        paymentNotPossible: 'Denne kontoen kan du ikke betale fra',
        transferBecauseItIs: 'fordi det er en',
        chooseAnotherAccountTransfer: 'Alt håp er ikke ute, velg en annen konto for å overføre',
        chooseAnotherAccountPayment: 'Alt håp er ikke ute, velg en annen konto for å betale',
    },
    invalidToAccount: 'Ugyldig kontonummer: {}',
    missingToAccountTransfer: {
        title: 'For å overføre penger må du ha minst to ulike kontoer som du kan overføre penger mellom.',
        tip: 'Tips!',
        description: 'Klikk på “Betal” hvis du skal sende penger til noen andre.',
        buttonText: 'Betal til noen andre',
    },
    tooManyCharacters: 'Du kan ikke ha mer enn {} tegn i meldingen.',
    tooManyCharactersKID: 'Du kan ikke ha mer enn {} siffer i KID-feltet for denne mottakeren.',
    transfer: 'Overfør',
    transferAmount: 'Overfør beløp',
    transferFromAccount: 'Fra konto',
    transferToAccount: 'Til konto',
    tryAgain: 'Prøv igjen',
    transactionListNoTransactionsTitle: 'Her har det ikke skjedd så mye!',
    transactionListNoMoreTransactionsToLoadTitle: 'Dette var alle transaksjoner de siste 12 månedene',
    transactionListCouldNotGetTransactions: 'Vi beklager, vi kunne ikke hente transaksjonene dine pga teknisk feil',
    transactionListCouldNotLoadMoreTransactions:
        'Vi beklager, vi det har skjedd en teknisk feil vi klarte ikke å laste flere transaksjoner. Prøv igjen litt senere.',
    transactionResultInfoTransactionNotCompleteMessage:
        'Denne betalingen kunne ikke fullføres fordi samme beløp ble overført mellom disse kontoene tidligere i dag.',
    transactionSuccessPushNudge: {
        title: 'Få pushvarsling neste gang du mottar en eFaktura',
        description:
            'Pushvarslinger gjør det enklere å holde seg oppdatert på endringer og ting du må ta stilling til i mobilbanken',
        buttonText: 'Gå til Pushvarslinger',
        abortButtonText: 'Ikke nå',
    },
    viewEFaktura: 'Se eFaktura',
    waitOnDataErrorMessage: 'Vi beklager, vi kunne ikke hente kontoene dine på grunn av en teknisk feil',
    continue: 'Fortsett',
    accountNumber: 'Kontonummer',
    accountName: 'Kontonavn',
    accountOwners: 'Kontoeiere',
    paymentItem: {
        title: 'Betaling',
        sureYouWantToUnapprove: 'Er du sikker på at du vil fjerne godkjenningen din fra denne betalingen?',
        sureYouWantToDelete: 'Er du sikker på at du vil slette denne betalingen?',
        isDeleted: 'Betalingen er slettet',
        restartSuccess: 'Betalingen er fullført',
    },
    paymentFrom: 'Betale fra',
    payAmount: 'Beløp',
    payFromAccount: 'Betal fra konto',
    paymentFromAccountName: 'Legg til navn eller bedrift',
    paymentAddOwnText: 'Egen tekst på betalingen',
    transferAddOwnText: 'Egen tekst på overføringen',
    ownTextPlaceholder: 'Skriv egen tekst her',
    paymentAddOwnTransactionText: 'Egen tekst på betalingen',
    kidHelpWithDash: {
        canHelp: 'Vi ser at denne KID-en bør inneholde en bindestrek - skal vi legge til en for deg?',
        addDash: 'Legg til bindestrek',
        gotHelp: 'Bindestrek lagt til! Du kan trygt fortsette betalingen.',
    },
    accountView: {
        noAccount: 'Fant ikke konto',
        disposible: 'Disponibelt',
        creditUnused: 'Du har i tillegg {} i kreditt på denne kontoen',
        creditUsed: '{} tilgjengelig av {} i kreditt',
    },
    receiverSearch: 'Navn eller kontonummer',
    receiverIsAdded: 'Mottakeren er lagt til',
    receiverIsDeleted: 'Mottakeren er slettet',
    receiverIsUpdated: 'Mottakeren er endret',
    receiversNotFound: 'Ingen treff i mottakerlisten din',
    search: 'Søk',
    name: 'Navn',
    addNewReceiver: 'Legg til ny mottaker',
    addNewPayment: 'Legg til ny betaling',
    addReceiver: 'Legg til mottaker',
    confirmDeleteReceiver: 'Er du sikker på at du vil slette denne mottakeren?',
    paymentValidation: {
        invalidAccountNumber: 'Her er det noe feil. Sjekk om du har riktig kontonummer',
        requiredField: 'Dette feltet er påkrevd',
        existingAccountNumber: 'Obs! Denne mottakeren finnes allerede i mottakerlisten som {}',
        chooseFromAccount: 'Vennligst velg fra konto',
        chooseToAccount: 'Du må velge en konto',
        receiverDontAcceptImmediatePayment: 'Denne mottakeren kan ikke motta straksbetaling',
        receiverDoesNotSupportImmediatePayment: 'Mottakeren støtter ikke straksbetalinger',
        chooseAmount: 'Du må skrive inn beløp',
        chooseValidDate: 'Dato må være i dag eller senere',
        noCoverage: 'Det er ikke nok penger på kontoen',
        invalidKID: 'Vi gjenkjenner ikke KID-nummeret. Sjekk at alle tall er riktige og forsøk igjen',
        missingKID: 'Legg til KID-nummer',
        missingNote: 'Legg til melding',
        amountLowerThanMinimum: 'Minimum å betale {} kr',
        amountExceedsMaximum: 'Maksgrense for en betaling er {} kr',
        amountExceedsMonthlyMaximum: 'Beløpet vil gå over månedlig betalingsgrense på {} kr',
    },
    minAmountToPay: 'Minimum å betale {} kr',
    transactions: 'Transaksjoner',
    history: 'Historikk',
    transactionDetails: {
        from: 'Fra',
        to: 'Til',
        date: 'Dato',
        bookingDate: 'Bokført',
        message: 'Melding',
        ownMessage: 'Egen tekst',
        purpose: 'Beskjed',
        category: 'Kategori',
        errorMessage: 'Vi beklager, vi kunne ikke hente transaksjonsdetaljer dine pga teknisk feil',
        receiver: {
            address: 'Mottakers adresse',
            bank: 'Mottakers bank',
            bicOrSwift: 'BIC/SWIFT',
        },
        bankReferenceNumber: 'Bankens arkivreferanse',
        kid: 'KID-nummer',
        download: 'Last ned som PDF',
        approvers: {
            createdBy: 'Opprettet av',
            approvedBy: 'Godkjent av',
        },
        singleApprover: 'Betalt av',
        infoWillCome: 'Informasjon kommer',
        multipleTransactionsDetails: 'Se mer i nettbank',
    },
    transactionTypes: {
        PAYMENT: 'Betaling',
        TRANSFER: 'Overføring',
        RESERVATION: 'Reservasjon',
        AUTOPAYMENT: 'AvtaleGiro',
        AUTOPAYMENTWITHINVOICE: 'AvtaleGiro med eFaktura',
        EFAKTURA: 'eFaktura',
        IMMEDIATE: 'Straksbetaling',
        INTEREST: 'Renter',
        FEE: 'Gebyr',
        CARD: 'Kortbetaling',
        WITHDRAWL: 'Uttak',
        INTERNATIONAL: 'Utenlandsbetaling',
        UNKNOWN: 'Ukjent',
        PAYMENT_OR_TRANSFER: 'Betaling eller overføring',
        SALARY: 'Lønn',
        INBOUND: 'Innbetaling',
        COMBINED_POSTING: 'Samlebetaling',
        VIPPS: 'Vipps',
        CASH: 'Kontantuttak',
    },
    transactionCategories: {
        INCOMING: 'Penger inn',
        OUTGOING: 'Penger ut',
        PAYMENT: 'Betaling',
        TRANSFER: 'Overføring',
        INTERNATIONAL: 'Utenlandsbetaling',
        PURCHASE: 'Varekjøp',
        SALARY: 'Lønn',
        INTEREST: 'Renter',
        CHARGE: 'Omkostninger',
        OTHER: 'Annet',
    },
    transactionStatus: {
        BOOKED: '',
        RESERVED: 'Reservert',
        CONFIRMATION: 'På vei',
    },
    transactionFilter: {
        filterTransactions: 'Søk og filtrer i transaksjoner',
        search: 'Søk',
        freetextPlaceholder: 'Søk etter transaksjoner',
        chooseCategory: 'Kategori',
        categoryPlaceholder: 'Velg ett eller flere alternativ',
        chooseAmount: 'Velg beløp',
        from: 'Fra',
        to: 'Til',
        choosePeriod: 'Velg periode',
        fromDateError: {
            invalid: 'Oppgi en gyldig fra-dato',
            required: 'Oppgi en gyldig fra-dato',
            outOfRangeMax: 'Oppgi en fra-dato som ikke er i fremtiden',
            outOfRangeMin: 'Datoen du har valgt er for langt tilbake i tid',
        },
        toDateError: {
            invalid: 'Oppgi en gyldig til-dato',
            required: 'Oppgi en gyldig til-dato',
            outOfRangeMax: 'Oppgi en til-dato som ikke er i fremtiden',
            outOfRangeMin: 'Datoen du har valgt er for langt tilbake i tid',
        },
        showHits: 'Vis treff',
        cancel: 'Avbryt',
        resetFilter: 'Nullstill filter',
        remove: 'Fjern filter: {}',
        editFilter: 'Endre filter: {}',
        openModal: 'Åpne filtreringsvindu',
        activeFilters: 'Aktive filtre',
        noMoreToLoad: 'Det var alle transaksjonene for søket ditt på denne kontoen',
        noHits: 'Fant ingen transaksjoner med det søket',
        reservedTransactionMessage: 'Viser ikke reserverte transaksjoner',
        choose: 'Velg',
        period: 'Periode',
        amount: 'Beløp',
        sentDirection: 'Penger sendt',
        receivedDirection: 'Penger mottatt',
        sent: 'sendt',
        received: 'mottatt',
        openSearch: 'Åpne søk',
        lastMonths: 'Siste {} måneder',
        lastMonth: 'Siste måned',
        goToAdvancedSearch: 'Gå til avansert søk ',
        toTheTop: 'Til toppen',
        didYouNotFindWhatYouWereLookingFor: 'Finner du ikke det du leter etter?',
        backToSearch: 'Tilbake til søk',
        removeChosen: 'Fjern valg',
    },
    transactionDownload: {
        open: 'Åpne',
        close: 'Lukk',
        downloadMenu: '{} nedlastningsmeny',
        exportToPdf: 'Last ned som PDF',
        exportToExcel: 'Eksporter til Excel',
        exportToCSV: 'Eksporter til CSV',
    },
    update: 'Oppdater',
    signing: {
        title: 'Signering av betaling',
    },
    clientError: {
        TIMEOUT: {
            title: 'Noe gikk galt.',
            description: 'Vi beklager, det tok litt lenger tid enn vi hadde tenkt. Du må gjerne prøve igjen',
        },
        INVALID_KID: {
            title: 'Angitt KID er ikke gyldig.',
            description: 'Sjekk at KID er skrevet inn korrekt eller utfør betalingen uten KID.',
        },
        ACCOUNT_BLOCKED_TO_RECEIVE_TRANSACTIONS: {
            title: 'Betalingen ble ikke fullført.',
            description: 'Det er ikke lenger mulig å betale til denne kontoen',
        },
        BANK_DISABLED: {
            title: 'Banken ikke tilgjengelig',
            description: 'Vennligst prøv igjen senere',
        },
        DUPLICATE_AVTALEGIRO_AGREEMENT: {
            title: 'Din AvtaleGiro ble ikke opprettet',
            description:
                'Det ser ut som det er en annen AvtaleGiro med samme KID nummer på denne mottakeren. Sjekk om opplysningene stemmer.',
        },
        DIRECT_DEBIT_AGREEMENT_EXISTS_IN_OTHER_BANK: {
            title: 'Din AvtaleGiro ble ikke opprettet',
            description:
                'Det ser ut som du allerede har denne AvtaleGiroen i en annen bank. Benytt `Hent AvtaleGiro` for å flytte den.',
        },
        DIRECT_DEBIT_CLIENT_DOES_NOT_HAVE_ACCESS: {
            title: 'Du har ikke tilgang til denne funksjonen',
            description: 'Det er kun administrator i avtalen som kan se og endre AvtaleGiro-avtaler',
        },
        CREDIT_ACCOUNT_BLOCKED: {
            title: 'Kontoen du prøver å betale til er blokkert',
            description: 'Det ser ut som man ikke kan sende penger til denne mottakeren.',
        },
        DUE_DATE_CANNOT_BE_IN_THE_PAST: {
            title: 'Betalingsdato kan ikke være i fortiden',
            description: 'Du må velge en dato i fremtiden for å gå videre.',
        },
        INVALID_CREDITOR_ACCOUNT_NUMBER: {
            title: 'Mottakers kontonummer er feil',
            description: 'Sjekk kontonummeret eller velg et annet kontonummer for å gå videre.',
        },
        CREDITOR_ACCOUNT_IS_CLOSED: {
            title: 'Mottakers konto er avsluttet',
            description:
                'Du kan ikke betale til dette kontonummeret fordi det er avsluttet. Velg et annet kontonummer for å gå videre.',
        },
        ACCOUNT_NOT_FOUND: {
            title: 'Denne kontoen finnes ikke',
            description: 'Denne kontoen finnes ikke.',
        },
        INACTIVE_CUSTOMER: {
            title: 'Noe gikk galt!',
            description: 'Ingen tilgang på grunn av brukerstatus.',
        },
        KUNDE_MANGLER: {
            title: 'Noe gikk galt!',
            description: 'Kunne ikke finne deg som kunde hos oss.',
        },
        DISPLAY_NAME_UPDATE_FAILED: {
            title: 'Noe gikk galt!',
            description: 'Vi kunne ikke oppdatere kontonavnet.',
        },
        MAX_TRANSACTION_AMOUNT_EXCEEDED: {
            title: 'Overføringen kan ikke gjennomføres',
            description: 'Du har overskredet det årlige sparebeløpet for denne kontoen',
        },
        INGEN_DEKNING: {
            title: 'Overføringen kan ikke gjennomføres',
            description: 'Det var ikke dekning for beløpet som ble forsøkt overført',
        },
        MANGLER_AVTALE: {
            title: 'Noe gikk galt!',
            description: 'Du har ikke tilgang til eFaktura på din avtale',
        },
        AVTALEGIRO_NOT_FOUND: {
            title: 'Noe gikk galt!',
            description: 'Vi kunne ikke finne AvtaleGiro',
        },
        LOAN_CALCULATION_ERROR: {
            title: 'Nedbetalingsplan kunne ikke beregnes',
            description: 'Kontakt oss så kan vi fikse problemet',
        },
        EXCEEDED_ACCUMULATED_TRANSACTION_AMOUNT: {
            title: 'Vi klarte ikke utføre betalingen.',
            description: 'Angitt beløp er større enn beløpsgrensen pr måned.',
        },
        CIRCUIT_BREAKER_OPEN: {
            title: 'Noe gikk galt!',
            description: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv på nytt litt senere.',
        },
        LOAN_ARREAR_ERROR: {
            title: 'Endring av lån ikke mulig',
            description: 'Vi kunne ikke gjennomføre endring på lånet grunnet utestående betaling',
        },
        SUSPECTED_FRAUD_RECIPIENT: {
            title: 'Mistenkelig mottaker',
            description:
                'På grunn av mistanke om svindel, kan vi ikke gjennomføre betalingen. Kontakt banken om du mener dette er feil.',
        },
        AMOUNT_GREATER_THAN_MAX_TRANSACTION_LIMIT: {
            title: 'Vi klarte ikke utføre betalingen.',
            description: 'Angitt beløp er større enn beløpsgrensen.',
        },
        LACK_OF_FUNDS: {
            title: 'Betalingen ble ikke gjennomført!',
            description: 'Det var ikke dekning for beløpet som ble forsøkt betalt',
        },
        NO_ACTIVE_AGREEMENTS: {
            title: 'Kunne ikke endre eFaktura-avtale',
            description: 'Vi fant ingen aktiv avtale, ta kontakt dersom det vedvarer',
        },
        NOT_AUTHORIZED_FOR_OPERATION: {
            title: 'Kunne ikke gjennomføre betalingen',
            description: 'Du har ikke tilgang til å gjøre denne operasjonen',
        },
        BSU_ACCOUNT_LIMIT_REACHED: {
            title: 'Kunne ikke betale inn på BSU konto',
            description: 'BSU kontoen har nådd maks-beløpet',
        },
        NO_ACCESS_TO_ACCOUNT: {
            title: 'Kunne ikke vise kontoinformasjon',
            description: 'Du har ikke tilgang til denne kontoen',
        },
        UNKNOW_CREDITOR: {
            title: 'Mottakeren støtter ikke AvtaleGiro',
            description: 'Verifiser at kontonummer er riktig',
        },
    },
    dateField: {
        diffTimeZoneMessage:
            'Vi forholder oss til tidssonen i Norge, hvis du er i et land i en annen tidssone er det viktig å beregne tid etter dette.',
        bankHolidayMessage: 'Vær oppmerksom på at betalingen gjennomføres første hverdag etter valgt dato.',
        invalidMessage: 'Ugyldig dato.',
        requiredMessage: 'Dato er påkrevd.',
        greaterThanDateMessage: 'Denne datoen er ugyldig, datoen må vera {} eller seinare.',
        lessThanDateMessage: 'Denne datoen er ugyldig, datoen kan ikkje {}.',
        title: 'Velg dato',
        today: 'I dag',
        paymentInterval: {
            titlePayment: 'Betalingen skal gjentas',
            titleTransfer: 'Overføringen skal gjentas',
            titleEnd: 'Avtalen avsluttes',
            alias: 'Gjentas',
            lastPaymentDate: 'Avsluttes',
            noLastPaymentDate: 'Aldri',
            withEndDate: ' til {} ',
        },
        recurringPaymentInterval: {
            DAILY: 'Daglig',
            WEEKLY: 'Ukentlig',
            EVERY_TWO_WEEKS: 'Hver andre uke',
            MONTHLY: 'Månedlig',
            EVERY_TWO_MONTHS: 'Hver andre måned',
            QUARTERLY: 'Kvartalsvis',
            EVERY_FOUR_MONTHS: 'Hver fjerde måned',
            SEMIYEARLY: 'Hvert halvår',
            YEARLY: 'Årlig',
            UNKNOWN: 'Ukjent',
        },
        recurringPaymentDateInterval: {
            DAILY: ' og daglig',
            WEEKLY: ' og ukentlig',
            EVERY_TWO_WEEKS: ' og hver andre uke',
            MONTHLY: ' og månedlig',
            EVERY_TWO_MONTHS: ' og hver andre måned',
            QUARTERLY: ' og kvartalsvis',
            EVERY_FOUR_MONTHS: ' og hver fjerde måned',
            SEMIYEARLY: ' og hvert halvår',
            YEARLY: ' og årlig',
            UNKNOWN: '',
        },
        endDates: {
            NEVER: 'Aldri',
            TO_END_OF_YEAR: 'Ut året',
            IN_3_MONTHS: 'Om 3 måneder',
            IN_6_MONHTS: 'Om 6 måneder',
            IN_12_MONTHS: 'Om 12 måneder',
            CUSTOM: 'Velg egen dato',
        },
    },
    receiverNameOverride: 'Du har lagret dette kontonummeret som {}.',
    toggleKid: 'Bytt til KID',
    toggleNote: 'Bytt til melding',
    amountNote: {
        [NoteTypes.MESSAGE]: {
            label: 'Melding',
            placeholder: 'Legg til melding',
        },
        [NoteTypes.KID]: {
            label: 'KID',
            placeholder: 'Legg til KID',
        },
        [NoteTypes.KID_OR_MESSAGE]: {
            label: 'KID/Melding',
            placeholder: 'Legg til KID eller melding',
        },
    },
    payTo: 'Betal til',
    chooseAccount: 'Velg konto',
    favoriteAccount: {
        favoriteAccountCardTitle: 'Velg en favorittkonto',
        favoriteAccountCardButtonText: 'Legg til favorittkonto',
        favoriteAccountCardDescription: 'Med en favorittkonto blir det enda enklere å betale og overføre.',
        favoriteAccountModalTitle: 'Velg favorittkonto',
        favoriteAccountModalDescription:
            'Du kan når som helst endre favorittkonto hvis du vil bytte til en annen konto.',
        saveFavoriteAccountButtonText: 'Lagre',
        favoriteAccountSaved: 'Favorittkonto er valgt',
        frontpageFavoriteAccountButtonText: 'Kom i gang',
        frontpageFavoriteAccountModalText: 'Med en favorittkonto blir betaling og overføring enda enklere.',
        favioriteAccountIllustrationImageAltText: 'Illustrasjonsbilde av mobilbank-forside med valgt favorittkonto.',
    },
    dismissKeyboard: 'Ferdig',
    accountDetails: {
        seeDetails: 'Se kontodetaljer',
        moreInfoAboutThisAccount: 'Mer informasjon om denne kontoen',
        seeAccountDetails: 'Se kontodetaljer',
        copyAccountNumber: 'Kopier kontonummer',
        copyIBAN: 'Kopier IBAN',
        cardsConnectedToTheAccount: 'Kort knyttet til kontoen',
        card: 'Bankkort',
        accountName: 'Kontonavn',
        accountProductName: 'Produktnavn',
        accountDetailsErrorMessage: 'Vi beklager, vi kunne ikke hente kontodetaljene dine på grunn av en teknisk feil',
        mainOwner: 'Hovedeier',
        owner: 'Eier',
        accountAccess: 'Kontotilganger',
        addAuthorizedCustomer: {
            responsibility: 'Det er ditt ansvar som kontohaver å informere disponenten om punktene under.',
            shareAccount: 'Del konto',
            chooseWho: 'Hvem ønsker du å dele med?',
            mustBeCustomer: 'Husk at personen må være kunde i banken.',
            mustBeCustomerWarning: 'Personen må være kunde i banken',
            confirmText: 'Du gir {} tilgang til "{}" med kontonummer {}',
            ssid: 'Skriv fødselsnummer',
            elevenCharacters: '11 siffer',
            ssidError: 'Sjekk at du har skrevet riktig fødselsnummer',
            fillName: 'Skriv fullt navn',
            fullname: 'Fornavn og etternavn',
            nameError: 'Navnet må samsvare med fødselsnummeret',
            nextButton: 'Neste',
            backButton: 'Tilbake',
            shareAccountButton: 'Del konto nå',
            shareSuccess: 'Kontoen er delt!',
            doneButton: 'Ferdig',
            deleteConfirmationQuestion: 'Er du sikker på at du vil fjerne {} som disponent av kontoen?',
            deleteConfirmationButton: 'Ja, jeg er sikker',
            deleteCancelButton: 'Avbryt',
            deleteConfirmation: '{} er ikke lenger disponent av denne kontoen.',
            confirmTitle: 'Kort oppsummert',
            termsTitle: 'Vilkår',
            termsSharingAccountInfo: 'Den du deler konto med vil kunne:',
            termsSharingAccountInfoList: {
                itemOne: 'Gjøre uttak av kontanter',
                itemTwo: 'Gjennomføre betalinger fra konto',
                itemThree: 'Se kontoforholdet',
                itemFour: 'Disponere konto i disponentens egen nettbank eller mobilbank',
                itemFive: 'Se kontoutskrifter og årsoppgaver fra datoen kontoen ble opprettet',
            },
            termsIncludingInfo: 'Dette innebærer blant annet at:',
            termsIncludingInfoList: {
                itemOne:
                    'Beløpsgrense for disposisjonsretten følger den beløpsgrensen som gjelder for disponentens digitalbank',
                itemTwo: 'Disponenten vil kunne inngå avtale om AvtaleGiro på vegne av kontohaver',
                itemThree:
                    'Disponenten skal bruke sin egen personlige sikkerhetsinformasjon og sin egen BankID, ikke kontohavers.',
            },
            deleteAuthorizedCustomer: 'Fjern disponent',
        },
        details: 'Detaljer',
        openedDate: 'Åpningsdato',
        iban: 'IBAN',
        bic: 'BIC/SWIFT',
        sepaBic: 'BIC/SWIFT fra EU/EØS + Sveits + Storbritannia',
        routingBic: 'BIC/SWIFT alle andre land',
        couldNotSave: 'Vi beklager, endringene ble ikke lagret. Prøv igjen senere',
        maxCharacters: 'Du kan ha maks {} tegn',
        accountType: 'Kontotype',
        mappedAccountType: {
            BSU: 'BSU',
            BSU_PLUSS: 'BSU Pluss',
            CLIENT_ACCOUNT: 'Klientkonto',
            CURRENCY_ACCOUNT: 'Valutakonto',
            CURRENCY_LOAN: 'Valutalån',
            ESTATECREDIT: 'Flexilån',
            GUARANTEE: 'Garanti',
            LOAN: 'Lån',
            RDS: 'RDS',
            SAVING: 'Sparekonto',
            SPENDING: 'Brukskonto',
            STOCKSAVINGS: 'Aksjesparekonto',
            SURETY: 'Kausjon',
            TAXWITHDRAW: 'Skattetrekkskonto',
            FLEXILOAN: 'Flexilån',
            UNKNOWN: 'Ukjent',
        },
        orgContact: 'Kontakt oss',
    },
    accountsList: {
        errorMessage: 'Noe gikk galt ved henting av kontoene dine',
        noAccountsHeader: 'Du har ingen kontoer',
        noAccountsDescription: 'Kontakt oss gjerne så hjelper vi deg i gang.',
        noAccountsDescriptionWithButton:
            'Trykk på lenken under for å gå til skjema for oppretting av kontoer, eller ta kontakt med oss så hjelper vi deg i gang.',
        createAccount: 'Ny konto',
        createNewAccount: 'Opprett ny konto',
        infoOnAccounts: 'Åpne en ny sparekonto eller brukskonto',
        totalBalance: 'Totalt',
        clauseWithoutForeignCurrency: 'Valutakontoer er ikke med i beregningen',
        emptyAccountsGroup: 'Flytt kontoer hit for å opprette en ny gruppe',
    },
    accountInterest: {
        header: 'Renter',
        types: {
            [InterestType.CREDIT]: {
                interest: 'Kredittrente',
                above: 'Kredittrente over',
                upTo: 'Kredittrente opptil',
            },
            [InterestType.DEBIT]: {
                interest: 'Innskuddsrente',
                above: 'Innskuddsrente over',
                upTo: 'Innskuddsrente opptil',
            },
        },
        overdraftInterest: 'Overtrekksrente',
        grantedOverdraftInterest: 'Bevilget overtrekksrente',
        notYetCapitalizedInterest: 'Renter beregnet, ikke bokført',
    },
    invoiceArchive: {
        noInvoices: 'Ingen eFaktura',
        documentType: {
            DOCUMENT: 'Dokument',
            EFAKTURA: 'eFaktura',
            UNKNOWN: 'Ukjent',
        },
        status: {
            PAID: 'Godkjent',
            NEW: 'Ny',
            UNPAID: 'Ubetalt',
            DELETED: 'Slettet',
            APPROVED: 'Godkjent',
            HAS_AVTALEGIRO: 'AvtaleGiro',
            UNKNOWN: 'Ukjent',
        },
    },
    profile: {
        myProfile: 'Min profil',
        messages: 'Meldinger',
        letters: 'Dokumenter',
        switchBank: 'Velg bank',
        switchBankAndAgreement: 'Velg bank eller avtale',
        switchAgreement: 'Velg avtale',
        unreadMessagesSingle: 'du har {} ulest melding',
        unreadMessagesplural: 'du har {} uleste meldinger',
        agreementError:
            'Vi klarte dessverre ikke å hente avtalene dine akkurat nå. Prøv på nytt litt senere, eller kontakt banken om problemet vedvarer.',
    },
    periodicControl: {
        intro: 'Det er viktig at vi har riktig kontaktinfo på deg, sånn at vi kan informere deg om viktige ting relatert til ditt kundeforhold',
        correctContactInfo: 'Stemmer informasjonen vi har om deg?',
        noEdit: 'Nei, endre',
        yesCorrect: 'Ja, det stemmer',
        thanks: 'Takk for hjelpen',
        howToEdit:
            'Dersom du trenger å gjøre flere endringer av kontaktinformasjon, kan du gjøre det under menypunktet Profil og Innstillinger',
        backToMobileBank: 'Til mobilbanken',
        backToNettbank: 'Til nettbanken',
        error: 'Ojsann!',
        errorTitle: 'Noe gikk galt!',
        cancel: 'Avbryt',
        tryAgain: 'Prøv igjen',
    },
    contactInfo: {
        editContactInfo: 'Endre kontaktinformasjon',
        contactInfo: 'Din kontaktinformasjon',
        email: 'E-post',
        mobile: 'Mobilnummer',
        address: 'Adresse',
        emailMissing: 'Ingen registrert e-postadresse',
        mobileMissing: 'Ingen registrerte telefonnummer',
        addressMissing: 'Ingen registrert adresse',
        save: 'Lagre',
        success: 'Kontaktinformasjon ble oppdatert',
        messages: 'Gå til meldinger',
        stepUp: {
            text: 'Vi er nødt til å forsikre oss om at ingen forsøker å utgi seg for å være deg. Gjennom en enkel bildeverifisering får du igjen tilgang til endring av telefonnummer.',
            link: 'Kom i gang',
        },
        signingError: {
            contactMessage: 'Hvis feilen vedvarer, ta kontakt med oss.',
            message:
                'Signeringen feilet! Det kan være at epostadressen eller mobilnummeret ikke var gyldig. Sjekk om du har skrevet de riktig, og prøv igjen.',
        },
        warnings: {
            email: 'For å endre epost-en må du sende oss en melding.',
            mobile: 'For å endre mobilnummeret må du sende oss en melding.',
            mobileDesktop: 'Endring av mobilnummer kan gjøres i mobilbanken eller ved å sende oss en melding.',
            address: 'Endring av adresse må gjøres i folkeregisteret.',
        },
        errors: {
            foundNoInfo: 'Fant ingen kontaktinformasjon',
            wrongEmailFormat: 'E-post må skrives i riktig format, for eksempel “navn@epost.no”',
            wrongMobileFormat: 'Feil format på telefonnummeret',
            emailNoChange: 'E-postadressen er uendret',
            mobileNoChange: 'Mobilnummeret er uendret',
        },
    },
    companyInfo: {
        generalManagerNotFound: 'Fant ikke daglig leder!',
        editCompanyInfo: 'Informasjon om daglig leder',
        editDescription:
            'Her kan du registrere eller endre telefonnummer og e-postadresse for deg som daglig leder. Vær oppmerksom på at denne informasjonen blir relatert til din rolle i bedriften, og ikke som privatperson.',
        editNameWarning: 'Endring av navn må gjøres gjennom brønnøysundregisteret',
        companyInformation: 'Bedriftsinformasjon',
        companyName: 'Navn på bedrift',
        organisationNumber: 'Organisasjonsnummer',
        address: 'Adresse',
        generalManager: 'Daglig leder',
        editGeneralManager: 'Endre kontaktinfo for daglig leder',
        cannotEditGeneralManager:
            'Det er bare den registrerte daglig leder som har mulighet til å endre kontaktinfo om daglig leder',
        updateSuccess: 'Daglig leder oppdatert',
        errors: {
            foundNoBusinessInformation: 'Fant ingen bedriftsinformasjon',
            invalidEmail: 'E-post må skrives i riktig format, for eksempel “navn@epost.no”',
            invalidMobile: 'Feil format på telefonnummeret',
        },
    },
    updatePaymentLimits: {
        validation: {
            cannotExceedMonthly:
                'Betalingsgrensen for en betaling kan ikke være større enn betalingsgrensen for en måned.',
            bankRestricted: 'Maksgrense for en betaling kan ikke være høyere enn {} kr',
            bankRestrictedMonthly: 'Maksgrense for en måned kan ikke være høyere enn {} kr',
            fillInField: 'Fyll inn feltet',
        },
        result: {
            rejectedTitle: 'Oj sann!',
            rejectedInfo:
                'Vi beklager dette gikk ikke helt etter planen. Sjekk om betalingsgrensene ble oppdatert før du prøver på nytt.',
            check: 'Sjekk betalingsgrenser',
            success: 'Betalingsgrenser er oppdatert',
            close: 'Lukk',
            toFrontPage: 'Til forsiden',
        },
        missingRights: 'Du har ikke rettigheter til å endre betalingsgrenser',
        maxTransactionAmount: 'Maksgrense for en betaling',
        maxMonthlyTransactionAmount: 'Maksgrense for en måned',
        update: 'Endre maksgrense',
        stepUpRequired: {
            title: 'Økt sikkerhet',
            text: 'Endring av beløp krever høy sikkerhet. For å gjøre dette må du verifisere deg. Det går raskt, og når du er ferdig åpner vi samtidig opp mer funksjonalitet for deg i mobilbanken.',
            text2: 'Det er enkelt og tar kun et par minutter.',
            stepUpButton: 'Kom i gang',
        },
        mobileRiskyDevice: {
            title: 'Økt sikkerhet',
            text: 'Endring av beløp krever høy sikkerhet. For å gjøre dette må du kontakte oss direkte.',
            text2: 'Det kan du gjøre her',
            buttonText: 'Ring oss',
        },
        desktopRiskyDevice: {
            title: 'Økt sikkerhet',
            text: 'Endring av beløp krever høy sikkerhet. Derfor må dette gjennomføres i mobilbanken.',
            text2: 'Har du ikke mobilbank tilgjengelig, kan du kontakte oss direkte.',
        },
        currentlyYouHavePaid: 'Hittil har du betalt {}',
    },
    closeWindow: 'Lukk vindu',
    withdrawals: {
        infoAboutNumberOfWithdrawalsLeft: 'Du har {} gebyrfrie uttak igjen {} fra denne kontoen.',
        oneWithdrawalLeft: 'Du har 1 gebyrfritt uttak igjen {} fra denne kontoen.',
        noWithdrawalsLeft:
            'Du har ikke flere gebyrfrie uttak i år. Alle uttak fra kontoen vil ha et gebyr i henhold til prislistene våre.',
        freeWithdrawals: 'Gebyrfrie uttak igjen',
        freeWithdrawalsOf: '{} av {}',
        withdrawalPeriods: {
            ANNUALLY: 'i år',
            BI_ANNUALLY: 'denne to-årsperioden',
            MONTHLY: 'denne måneden',
            QUARTERLY: 'dette kvartalet',
            SECOND_MONTH: 'denne to-månedsperioden',
            TERTIALY: 'denne tredjedelen av året',
            UKNOWN: 'denne perioden',
        },
    },
    openPaymentWindow: 'Åpne betalings- og overføringsvindu',
    documentsForSigning: 'Oppgaver til gjennomgang',
    kredittbanken: {
        category: {
            ANSWER_KYC: 'Fyll ut kundeerklæring',
            APPLICATION: '',
            UNKNOWN: '',
        },
        kycInfo:
            'Du må fylle ut kundeerklæring slik at vår leverandør Kredittbanken har oppdatert og riktig informasjon om deg. Det går kjapt å svare!',
    },
    loanApplications: {
        type: {
            HOUSE_LOAN_INCREASE: 'Søknad om økt boliglån',
            PROOF_OF_FINANCING: 'Søknad om finansieringsbevis',
            NEW_LOAN: 'Søknad om nytt boliglån på eksisterende bolig',
            MOVING: 'Søknad om flytting av boliglån',
            HOUSE_LOAN: 'Søknad om boliglån',
            UNKNOWN: '',
        },
        status: {
            ACTIVE: 'Søknad påbegynt',
            WAITING_FOR_CO_BORROWER: 'Venter på medlåntaker',
            APPLICATION_BEING_PROCESSED: 'Behandles',
            APPROVED: 'Nytt lånetilbud',
            BEING_PREPARED_FOR_PAYMENT: 'Klargjøres for utbetaling',
            PAID_OUT: 'Utbetalt',
            REFUSED: 'Avslått',
            CLOSED: 'Avsluttet',
            EXPIRED: 'Utløpt',
            INFORMATION_BEING_PROCESSED: 'Opplysningene blir behandlet',
            WAITING_FOR_YOUR_APPROVAL: 'Venter på ditt samtykke',
            UNKNOWN: '',
        },
        needsAction: 'Krever handling',
    },
    importantTask: 'viktig oppgave',
    importantTasks: 'viktige oppgaver',
    updateToSwitchLanguage: 'For å kunne velge språk må du oppdatere til siste versjon av mobilbanken',
    unknownAccountWarning: 'Dette er en konto du ikke eier, dobbeltsjekk om det er riktig kontonummer',
    unknownAccount: 'Ukjent konto',
    futurePaymentLimitWarning:
        'Én eller flere av betalingene dine vil overskride beløpsgrensen. Du må endre betalingen, eller justere beløpsgrensen under innstillinger',
    goToTop: 'Gå til toppen',
    goBack: 'Gå tilbake',
    tasks: 'Oppgaver',
    otherTasks: 'Andre oppgaver',
    edit: 'Rediger',
    onlyOneAccount: 'Du har bare èn konto!',
    accountNeedsMultipleApproversTransactionInfoMessage:
        'Denne kontoen krever flerpartsgodkjenning. Klikk deg inn på transaksjonene for å se hvem som har betalt og godkjent.',
    more: 'Mer',
    moveAvtaleGiro: {
        whenYouStartTheProcess:
            'Når du starter prosessen ved å logge deg inn med BankID, får du en oversikt over aktive\n' +
            'AvtaleGiro-avtaler du har i andre banker. Da kan du velge alle eller kun et utvalg AvtaleGiro\n' +
            'som flyttes over til oss.',
        quickAndIntuitive:
            'Det hele er kjapt og intuitivt, og du får gleden av å samle alt på ett sted for en enklere bankhverdag!',
        startProcess: 'Start prosessen',
        chooseAvtaleGiros: 'Velg AvtaleGiro',
        moveOn: 'Videre',
        notaBene: 'NB!',
        notaBeneDescription:
            '{} Skulle du ha AvtaleGiro liggende til forfall, blir disse også overført. Husk derfor å ha nok penger disponibelt på konto før du flytter.',
        moveAvtaleGiro: 'Flytt AvtaleGiro ({})',
        newHome: 'Dette vil bli AvtaleGiroenes nye hjem',
        chooseAvtaleGiroPaymentAccount: 'AvtaleGiroens betalingskonto',
        avtaleGirosInOtherBanks: 'AvtaleGiro i andre banker',
        areYouSure: 'Er du sikker på at du vil flytte AvtaleGiro?',
        movedByMistake:
            'Skulle en AvtaleGiro være flyttet ved en feil, må du henvende deg til banken du flyttet den fra, og starte en ny flytteprosess der ifra.',
        yesMoveAvtaleGiro: 'Ja, utfør flyttingen',
        moveHasStarted: 'Flyttingen er gjennomført!',
        toAvtaleGiroPage: 'Til AvtaleGiro-siden',
        removeChosen: 'Fjern valgte',
        chooseAll: 'Velg alle',
        confirmation: 'Nå er enda flere AvtaleGiro samlet på ett sted',
        toFrontPage: 'Til forsiden',
        backToTheFrontpage: 'Tilbake til forsiden',
        ofChosen: '{} av {} valgt',
        summary: 'Oppsummering',
        youAreReadyToMove: 'Du er klar til å flytte over {} til {}, {}.',
        moveAvtaleGirosNow: 'Flytt AvtaleGiro nå',
        foundNoAvtaleGiros: 'Vi fant ingen AvtaleGiro fra andre banker',
        someAvtaleGirosMightHaveANewMaxAmount:
            'Det kan hende du har fått en ny maksgrense på avtalene dine. Dette kan du selv administrere på {}-siden.',
        errors: {
            debitAccountNotSelected: 'Du må velge en konto å betale AvtaleGiroene med!',
            noAvtaleGirosSelected: 'Du må velge minst én AvtaleGiro å flytte',
            couldNotFindExternalAvtaleGiros:
                'Vi klarer ikke hente inn AvtaleGiro fra andre banker akkurat nå. Vennligst prøv igjen nå eller litt senere. Om problemet vedvarer, kontakt oss under Hjelp og kontakt i menyen.',
            couldNotMoveSomeOrAllAvtaleGiros:
                'Vi klarte ikke å flytte en eller flere av AvtaleGiroene. Forsøk på nytt med knappen under.',
            accountsCouldNotBeFetched: 'Vi klarte ikke å laste inn kontoene dine',
            noValidAccounts: 'Vi fant ingen kontoer du kan betale AvtaleGiroene dine fra',
            ifThisIsWrongContactUs: 'Hvis dette er feil, kontakt oss under Hjelp og kontakt i menyen.',
        },
        rejected: {
            heading: 'Signeringen med BankID gikk ikke igjennom',
            description: 'Prøv igjen ved å trykke på knappen under. Hvis problemet vedvarer, ta kontakt med oss',
        },
    },
    accountIsBlocked: 'Kontoen er blokkert',
    messages: {
        oldMessagesWillBeRemoved: 'Fra og med 15. januar blir alle de gamle meldingene dine borte',
        ifYouWishToSaveThem: 'Hvis du ønsker å lagre noen av meldingene dine, vennligst gjør det i {} før 15. januar.',
        messagesText: 'Meldinger',
    },
    psd2Warning:
        'Du har valgt en betalingsmåte som kun brukerstedet, gjennom sin betalingsleverandør, kan gjøre endringer på. Du må derfor kontakte brukerstedet for videre hjelp',
    approveMultipleEFaktura: {
        approveEFaktura: 'Godkjenn eFaktura',
        toTheFrontpage: 'Til forsiden',
        seeEFaktura: 'Se gjenværende eFaktura',
        eFakturasWaiting: '{} eFaktura venter',
        approveAndPayNEFaktura: 'Godkjenn og betal ({})',
        subtotal: 'Til sammen {}',
        doYouWantToApproveAll: 'Vil du godkjenne alle?',
        youAreApprovingNEFakturasAtOnce: 'Du godkjenner {} eFaktura på én gang, totalt {}',
        youAreApprovingNEFakturasWithSharedAtOnce:
            'Du godkjenner {} eFaktura på én gang, hvor {} av dem er en delt eFaktura, totalt {}',
        choosePaymentAccount: 'Velg betalingskonto',
        allEFakturasArePaidFromThisAccount: 'Alle eFakturaene betales fra denne kontoen',
        doYouWishToPayFromDifferentAccounts: 'Ønsker du ulike kontoer for hver eFaktura, må du godkjenne enkeltvis',
        approveNow: 'Godkjenn nå',
        error: {
            chooseDebitAccount: 'Du må velge en betalingskonto',
            noCoverage: 'Det er ikke nok penger på kontoen',
            exceedsMaximumAmount: 'Maksgrense for en betaling er {} kr per betaling',
            exceedsMonthlyMaximumAmount: 'Det totale beløpet vil gå over månedlig betalingsgrense på {} kr',
        },
        signingResult: {
            error: {
                nEFakturaWasNotApproved: '{} av eFakturaene ble ikke godkjent',
                looksLikeWeCouldNotApproveAllYourEFaktura:
                    'Det ser ut som vi ikke klarte å godkjenne alle eFakturaene. Gjør eventuelle endringer og forsøk igjen nå, eller prøv på nytt senere.',
            },
            success: {
                allEFakturasWasApproved: 'Alle eFakturaene ble godkjent!',
                eFakturasArePaidOnDueDate:
                    'Merk at de betales på betalingsdato definert i de enkelte eFakturaene. Har en eFaktura forfalt? Da settes betalingsdatoen til i dag eller nærmeste bankvirkedag.',
            },
        },
    },
    commonErrors: {
        errorGettingAccounts: 'Feil i henting av kontoer',
        gettingAccountsFailed: 'Henting av kontoer feilet',
        tryLoadingAgain:
            'Prøv å laste inn igjen. Om problemet vedvarer, vent et par timer, eller kontakt oss. Koden under kan forklare oss hva som er galt.',
        copyRCID: 'Kopier feilkode',
        paymentAndNextSalaryFailed: 'Neste lønn feilet',
        paymentFailed: 'Betalinger feilet',
        allPaymentServicesIsAffected:
            'Alle betalingstjenester berøres av dette, samt Neste lønn. Prøv å laste inn igjen. Om problemet vedvarer, vent et par timer, eller kontakt oss. Koden under kan forklare oss hva som er galt.',
        gettingEFakturaFailed: 'Henting av eFaktura feilet',
        thereIsAnErrorOnOurSide:
            'Det ser dessverre ut som noe er feil på vår side. Vennligst forsøk igjen litt senere. Våre teknikere er på saken!',
    },
};

export default nbTranslations;
